import {Link} from 'react-router-dom';
import {Suspense, useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";
import Header from "../Header.jsx";
import Button from "../component-assets/Button.jsx";
import ApiRequester from "../ApiRequester.jsx";
import MaterialIcon from "../component-assets/MaterialIcon.jsx";
import {
    actionAppearance,
    bulkDeleteModal,
    checkAll,
    convertIsoToLocal,
    iAmHigherAuthority,
    formCheck,
    formFail,
    formSuccess,
    handleSubmitActions,
    paginateData,
    showModal,
    sortFunc,
    swapModal,
    toggleCollapse,
    isBannerPresent, searchFunc
} from "../../libs.jsx";
import TableBody from "../component-assets/TableBody.jsx";
import TableHeaders from "../component-assets/TableHeaders.jsx";
import PaginationItems from "../component-assets/PaginationItems.jsx";
import {Pagination} from "react-bootstrap";
import BulkDeleteModal from "../component-assets/BulkDeleteModal.jsx";
import {v4 as uuidv4} from "uuid";
import Navigation from "../Navigation.jsx";
import PerPageModal from "../component-assets/PerPageModal.jsx";
import { getSession, setSession } from "../../services/session";

const ServerProfile = (props) => {
    let dData, bData, serverHeaderData, matchHeaderData, logHeaderData, virtualDeviceHeaderData;

    dData = getSession();

    serverHeaderData = [
        {label: "Config Name", key: "config_name", align: "left"},
        {label: "Value", key: "config_value", align: "left"},
        {label: "Data Type", key: "data_type", align: "center"},
        {label: "Description", key: "description", align: "left"}
    ];

    matchHeaderData = [
        {label: "Match Type", key: "type_name", align: "center"},
        {label: "Pattern", key: "pattern", align: "center"},
        {label: "Replacement", key: "replacement", align: "center"},
        {label: "Case Sensitive", key: "is_case_sensitive", align: "center", type: "bool", t: "True", f: "False"},
        {label: "Area", key: "area_name", align: "center"},
        {label: "Device", key: "device_name", align: "center"},
        {label: "Alarm Category", key: "event_category_name", align: "center"},
        {label: "Alarm Type", key: "event_type_name", align: "center"},
        {label: "TTL", key: "ttl", align: "center"}
    ];

    logHeaderData = [
        {label: "Timestamp", key: "create_time", align: "center", type: "datetime-utc", sorts: true},
        {label: "Log Event", key: "log_type_name", align: "center", sorts: true, filtered: true}
    ];

    virtualDeviceHeaderData = [
        {label: "Device Name", key: "device_name", align: "center"},
        {label: "Device Type", key: "device_type_name", align: "center"},
    ]

    // Permission Variables
    const [editRights, setEditRights] = useState(iAmHigherAuthority(10, dData.role_weight));
    const [read, setRead] = useState(true);
    // Main Page Variables
    const [serverId, setServerId] = useState(props?.id ? parseInt(props.id) : 0);
    const [count, setCount] = useState(0);
    const [pCount, setPCount] = useState(0);
    const [iCount, setICount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [deviceData, setDeviceData] = useState([]);
    const [dbValid, setDbValid] = useState(null);
    const [dbData, setDbData] = useState([]);
    const [localData, setLocalData] = useState([]);
    const [serverActiveDb, setServerActiveDb] = useState([]);
    const [serverOriginDb, setServerOriginDb] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [tabItem, setTabItem] = useState("basic");
    // Basic Information Variables
    const [basicData, setBasicData] = useState([]);
    const [serverName, setServerName] = useState("");
    const [macAddr, setMacAddr] = useState("");
    const [product, setProduct] = useState("");
    const [productId, setProductId] = useState("");
    const [areaId, setAreaId] = useState("");
    const [areaName, setAreaName] = useState("");
    const [isActive, setIsActive] = useState(0);
    const [interfaceName, setInterfaceName] = useState("");
    const [interfaceId, setInterfaceId] = useState(0);
    const [os, setOS] = useState("");
    const [hardware, setHardware] = useState("");
    const [ipAddr, setIPAddr] = useState("");
    const [locationData, setLocationData] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [basicLoaded, setBasicLoaded] = useState(false);
    const [areaLoaded, setAreaLoaded] = useState(false);
    const [isOffline, setIsOffline] = useState(null);
    // Active Table Variables
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [search, setSearch] = useState("");
    const [sorter, setSorter] = useState({
        sortColumn: "config_name",
        sortOrder: "asc"
    });
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    // Match Term Variables
    const [matchTermsRows, setMatchTermsRows] = useState([]);
    const [matchOrigin, setMatchOrigin] = useState([]);
    const [matchActive, setMatchActive] = useState([]);
    const [matchIdList, setMatchIdList] = useState([]);
    const [virtualDeviceData, setVirtualDeviceData] = useState([]);
    const [virtualDeviceRows, setVirtualDeviceRows] = useState([]);
    const [virtualIdList, setVirtualIdList] = useState([]);
    const [virtualDeviceTypeData, setVirtualDeviceTypeData] = useState([]);
    const [matchTermTab, setMatchTermTab] = useState("terms");
    const [storedMatchIndex, setStoredMatchIndex] = useState(0);
    const [matchDeviceMap, setMatchDeviceMap] = useState([]);
    const [tmpDeviceMap, setTmpDeviceMap] = useState([]);
    const [matchAreaMap, setMatchAreaMap] = useState([]);
    const [tmpAreaMap, setTmpAreaMap] = useState([]);
    const [dContent, setDContent] = useState([]);
    const [serverTableRows, setServerTableRows] = useState([]);
    const [addMatchTypeId, setAddMatchTypeId] = useState(1);
    const [eventCatId, setEventCatId] = useState(1);
    const [eventTypeId, setEventTypeId] = useState(1);
    const [eventCatData, setEventCatData] = useState([]);
    const [eventTypeData, setEventTypeData] = useState([]);
    const [eventCatOptions, setEventCatOptions] = useState([]);
    const [eventTypeOptions, setEventTypeOptions] = useState([]);
    const [sorter2, setSorter2] = useState({
        sortColumn: "match_pattern",
        sortOrder: "asc"
    });
    const [ppRules2, setPRules2] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    // Logging Variables
    const [logOriginData, setLogOriginData] = useState([]);
    const [logActiveData, setLogActiveData] = useState([]);
    const [logTableRows, setLogTableRows] = useState([]);
    const [logHeaderFilters, setLogHeaderFilters] = useState([]);
    const [logSorter, setLogSorter] = useState({
        sortColumn: "create_time",
        sortOrder: "desc"
    });
    const [logPPRules, setLogPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [logPage, setLogPage] = useState(1);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    // MQ Status Table Variables
    const [mqOriginData, setMqOriginData] = useState([]);
    const [uptime, setUptime] = useState("");
    const [lastReboot, setLastReboot] = useState("");
    const [activeAlarmsCount, setActiveAlarmsCount] = useState("");
    const [recentAlarmTime, setRecentAlarmTime] = useState("");
    const [lastHeartbeat, setLastHeartbeat] = useState("");
    const [evActive, setEvActive] = useState(false);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", payload: {device_filter: serverId?.toString(),
                                campus_id: campusId}, procedure: "sp_dev_getPalcareDevicesByCampusID",
                                reqType: "stored", "read-only": read}).then(data => {
                setBasicData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, "read-only": true,
                                procedure: "sp_dev_getareasbycampusid", reqType: "stored"}).then(data => {
                setLocationData(data);
                setAreaLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, "read-only": true,
                                payload: {device_filter: serverId, campus_id: campusId},
                                procedure: "getserverstatushistory", reqType: "stored"}).then(data => {
                setDeviceData(data);
            });
            {dData?.campusData[dData?.acnt.toString()]?.is_cloud &&
                ApiRequester({reqEndpoint: "myfetch", pKey: "palcare_device_id", pVal: serverId,
                                procedure: "getserverlogs", reqType: "stored", "read-only": true}).then(data => {
                    setLogOriginData(data);
                });
            }
            setRead(true);
            setCount(() => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setPCount(count => count - 1);
        }, 1000);
        if (pCount >= 0 && pCount % 5 === 0 && macAddr && macAddr?.length > 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "mac_addr", pVal: macAddr.replaceAll(":", ""),
                                Tbl: "core_active_event_snapshots", procedure: "fetchbyparameter", reqType: "direct", "read-only": true}).then(data => {
                setLocalData(data ? data : []);
                if (data && data.length > 0){
                    setPCount(-1);
                }
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "server_id", pVal: macAddr.replaceAll(":", ""),
                                Tbl: "core_config", procedure: "fetchbyparameter", reqType: "direct", "read-only": read}).then(data => {
                setServerOriginDb(data ? data : []);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "palcare_server_id", "read-only": true,
                                pVal: macAddr.replaceAll(":", ""),
                                payload: {palcare_server_id: macAddr.replaceAll(":", "")},
                                procedure: "getserverstatusbymac", reqType: "stored"}).then(data => {
                setMqOriginData(data ? data : []);
            });
            setRead(true);
        }
        return () => clearInterval(interval);
    }, [pCount, macAddr]);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setICount(count => count - 1);
        }, 1000);
        if (iCount <= 0 && [1, 2].includes(interfaceId)){
            ApiRequester({reqEndpoint: "myfetch", pKey: "palcare_device_id", pVal: serverId,
                                payload: {campus_id: campusId, palcare_device_id: serverId},
                                procedure: "getmatchterms", reqType: "stored"}).then(data => {
                setMatchOrigin(data ? data : []);
            });
            ApiRequester({reqEndpoint: "myfetch", payload: {campus_id: campusId}, procedure: "getvirtualdevices",
                                reqType: "stored", "read-only": read}).then(data => {
                setVirtualDeviceData(data ? data : []);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_hwi_device_type",
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setVirtualDeviceTypeData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_event_categories",
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setEventCatData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_event_types",
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setEventTypeData(data);
            });
            setICount(() => 600);
        }
        return () => clearInterval(interval);
    }, [iCount, interfaceId]);

    useEffect(() => {
        if (![basicLoaded, areaLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [basicLoaded, areaLoaded]);

    useEffect(() => {
        let pRules = paginateData(serverActiveDb, page, perPage);
        setPRules(pRules);
        if (serverActiveDb.length > 0) {
            serverActiveDb.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setServerTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={serverActiveDb} checkbox={false} unk={"a-"}
                                      writeAccess={false} addlEditKey={""} addlEditCheck={false} actionAppearance={() => {}}
                                      tableHeaders={serverHeaderData} editModal={() => {}} parentComponent={"Server"} dData={dData}
                                      modal={false} checkboxlist={[]} setCheckboxId={() => {}} checkidkey={""} />);
    }, [serverActiveDb, sorter, page, perPage]);

    useEffect(() => {
        setVirtualDeviceRows(<TableBody start={0} end={virtualDeviceData.length} tableData={virtualDeviceData} checkbox={true} unk={"vd-"}
                                      writeAccess={true} addlEditKey={""}
                                      actionAppearance={() => actionAppearance(0, virtualDeviceData.length, ["deleteVirtualBtn"], "uCheckVirtual")}
                                      checkboxId={"uCheckVirtual"}
                                      tableHeaders={virtualDeviceHeaderData} editModal={() => {}} parentComponent={"Server"} dData={dData}
                                      modal={false} checkboxlist={virtualIdList} setCheckboxId={(value) => {setVirtualIdList(value)}}
                                        checkidkey={"device_id"} />);
    }, [virtualDeviceData, virtualIdList]);

    useEffect(() => {
        let pRules = paginateData(matchActive, page2, perPage);
        setPRules2(pRules);
        if (matchActive.length > 0) {
            matchActive.sort((a, b) => sortFunc(a, b, sorter2.sortColumn, sorter2.sortOrder));
        }
        setMatchTermsRows(<TableBody start={pRules.start} end={pRules.end} tableData={matchActive} checkbox={editRights} unk={"b-"}
                                     writeAccess={editRights} addlEditKey={""} addlEditCheck={false}
                                     actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                     tableHeaders={matchHeaderData} editModal={editMatchModal} parentComponent={"Server"} dData={dData}
                                     modal={true} checkboxlist={matchIdList} setCheckboxId={(value) => {setMatchIdList(value)}}
                                     checkidkey={"matchterm_id"} />);
    }, [matchActive, sorter2, page2, perPage, matchIdList]);

    useEffect(() => {
        let pRules = paginateData(logActiveData, logPage, perPage);
        setLogPRules(pRules);
        if (logActiveData.length > 0) {
            logActiveData.sort((a, b) => sortFunc(a, b, logSorter.sortColumn, logSorter.sortOrder));
        }
        setLogTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={logActiveData} checkbox={false}
                                writeAccess={false} unk={"l-"} addlEditKey={""} addlEditCheck={false}
                                actionAppearance={() => {}}
                                tableHeaders={logHeaderData} editModal={() => {}} parentComponent={"InovonicsDevice"} dData={dData}
                                modal={false} checkboxlist={[]} setCheckboxId={() => {}}
                                checkidkey={""} tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)} />);
    }, [logActiveData, logSorter, logPage, perPage]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, input, pRules, searchKeys;

        searchKeys = ["config_name", "config_value", "description"];
        tmpData = searchFunc(search, serverOriginDb, searchKeys)

        pRules = paginateData(tmpData, page, perPage);
        if (input && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!input){
            setPage(storePage);
        }
        setPRules(pRules);
        setServerActiveDb(tmpData);
    }, [search, serverOriginDb]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, input, pRules;

        tmpData = logOriginData.filter(item => {
            return Object.keys(logHeaderFilters).every(key => {
                if (!logHeaderFilters[key] || logHeaderFilters[key].length === 0) return true;
                return logHeaderFilters[key].includes(String(item[key]));
            });
        });

        pRules = paginateData(tmpData, logPage, perPage);
        if (input && logPage > pRules.pageMax){
            setLogPage(pRules.pageMax);
        }else if (!input){
            setLogPage(storePage);
        }
        setLogPRules(pRules);
        setLogActiveData(tmpData);
    }, [logOriginData, logHeaderFilters]);

    useEffect(() => {
        // Area to perform search and front end filtering.
        let tmpData = [];
        for (let i=0; i < matchOrigin.length; i++){
            tmpData.push(matchOrigin[i]);
        }
        setMatchActive(tmpData);
    }, [matchOrigin]);

    useEffect(() => {
        // Performs realtime search of data into active filtered data
        if (mqOriginData.length > 0){
            setRecentAlarmTime(() => mqOriginData[0]?.recent_alarm_input_time !== undefined ? convertIsoToLocal(mqOriginData[0]?.recent_alarm_input_time) : "");
            setActiveAlarmsCount(() => mqOriginData[0]?.count_active_alarms !== undefined ? mqOriginData[0]?.count_active_alarms : "");
            setLastReboot(() => mqOriginData[0]?.last_reboot_date !== undefined ? convertIsoToLocal(mqOriginData[0]?.last_reboot_date) : "");
            setUptime(() => mqOriginData[0]?.uptime_hrs !== undefined ? mqOriginData[0]?.uptime_hrs : "");
            if (!dData?.campusData[dData.acnt.toString()]?.is_cloud){
                setLastHeartbeat(() => mqOriginData[0]?.create_time !== undefined ? convertIsoToLocal(mqOriginData[0]?.create_time) : "")
            }
        }
    }, [mqOriginData]);

    useEffect(() => {
        if (basicData.length > 0){
            setServerName(() => basicData[0]?.description ? basicData[0].description : "");
            setMacAddr(() => basicData[0]?.mac_addr ? basicData[0].mac_addr : "");
            setProduct(() => basicData[0]?.product ? basicData[0].product : "");
            setProductId(() => basicData[0]?.palcare_product_id ? basicData[0].palcare_product_id : "");
            setAreaId(() => basicData[0]?.area_id ? basicData[0].area_id : "");
            setAreaName(() => basicData[0]?.area_name ? basicData[0].area_name : "");
            setInterfaceName(() => basicData[0]?.palcare_interface_name ? basicData[0].palcare_interface_name : "");
            setInterfaceId(() => basicData[0]?.palcare_interface_id ? basicData[0].palcare_interface_id : "");
            setOS(() => basicData[0]?.os ? basicData[0].os : "");
            setHardware(() => basicData[0]?.hardware ? basicData[0].hardware : "");
            setIPAddr(() => basicData[0]?.ip_address ? basicData[0].ip_address : "");
            setIsActive(() => basicData[0]?.is_active ? 1 : 0);
            if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
                setLastHeartbeat(basicData[0]?.last_heard ? basicData[0].last_heard : "");
                setIsOffline(basicData[0]?.is_offline);
            }
            setBasicLoaded(true);
        }
    }, [basicData]);

    useEffect(() => {
        if (macAddr && macAddr !== ""){
            ApiRequester({reqEndpoint: "myvalidation", payload: {server_id: macAddr.replaceAll(":", ""), campus_id: campusId},
                                reqType: "ping"}).then(data => {
                setDbValid(data?.length > 0 ? data[0] : {});
            });
        }
    }, [macAddr]);

    useEffect(() => {
        let i, tmp = [];
        locationData.sort((a, b) => sortFunc(a, b, "area_name", "asc"));
        for (i = 0; i < locationData?.length; i++){
            tmp.push(
                <option key={"location-option"+i.toString()} value={locationData[i].area_id}>{locationData[i].area_name}</option>
            );
        }
        setLocationOptions(() => tmp);
    }, [locationData]);

    useEffect(() => {
        let i, tmp = [];
        for (i = 0; i < eventCatData?.length; i++){
            tmp.push(
                <option key={`event-cat-option-${i}`} value={eventCatData[i].event_category_id}>{eventCatData[i].event_category_name}</option>
            );
        }
        setEventCatOptions(() => tmp);
    }, [eventCatData]);

    useEffect(() => {
        let i, tmp = [];
        for (i = 0; i < eventTypeData?.length; i++){
            tmp.push(
                <option key={`event-type-option-${i}`} value={eventTypeData[i].event_type_id}>{eventTypeData[i].event_type_name}</option>
            );
        }
        setEventTypeOptions(() => tmp);
    }, [eventTypeData]);

    function editDBModal(){
        for (let i=0; i < serverOriginDb.length; i++){
            if (serverOriginDb[i]?.config_name.toLowerCase() === "in_serial_portname"){
                document.getElementById("serialIn").value = serverOriginDb[i]?.config_value;
                document.getElementById("serialInId").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "out_serial_portname"){
                document.getElementById("serialOut").value = serverOriginDb[i]?.config_value;
                document.getElementById("serialOutId").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "in_serial_msgdelimiter"){
                document.getElementById("in_serial_delimiter").value = serverOriginDb[i]?.config_value;
                document.getElementById("in_serial_delimiter_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "out_serial_msgdelimiter"){
                document.getElementById("out_serial_delimiter").value = serverOriginDb[i]?.config_value;
                document.getElementById("out_serial_delimiter_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "in_serial_baud"){
                document.getElementById("in_serial_baud").value = serverOriginDb[i]?.config_value;
                document.getElementById("in_serial_baud_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "out_serial_baud"){
                document.getElementById("out_serial_baud").value = serverOriginDb[i]?.config_value;
                document.getElementById("out_serial_baud_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "config_ttl"){
                document.getElementById("config_ttl").value = serverOriginDb[i]?.config_value;
                document.getElementById("config_ttl_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "config_env_sample_rate"){
                document.getElementById("config_env_sample_rate").value = parseInt(serverOriginDb[i]?.config_value) / 60;
                document.getElementById("config_env_sample_rate_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "config_environmental_processing"){
                document.getElementById("config_env_processing").checked = serverOriginDb[i]?.config_value === "YES";
                document.getElementById("config_env_processing_id").value = serverOriginDb[i]?.config_id;
                setEvActive(serverOriginDb[i]?.config_value === "YES");
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "config_inohightemp"){
                document.getElementById("config_high_temp").value = serverOriginDb[i]?.config_value;
                document.getElementById("config_high_temp_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "config_inolowtemp"){
                document.getElementById("config_low_temp").value = serverOriginDb[i]?.config_value;
                document.getElementById("config_low_temp_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "config_inolowbat"){
                document.getElementById("config_low_bat").value = serverOriginDb[i]?.config_value;
                document.getElementById("config_low_bat_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "in_checkintime"){
                document.getElementById("in_CheckinTime").value = serverOriginDb[i]?.config_value;
                document.getElementById("in_CheckinTime_id").value = serverOriginDb[i]?.config_id;
            }else if (serverOriginDb[i]?.config_name.toLowerCase() === "config_inoloccheckintime"){
                document.getElementById("config_inoLocCheckinTime").value = serverOriginDb[i]?.config_value;
                document.getElementById("config_inoLocCheckinTime_id").value = serverOriginDb[i]?.config_id;
            }
        }
        showModal("dbeditmodal");
    }

    function basicActionHandling(){
        document.getElementById("name-static").classList.toggle("d-none");
        document.getElementById("name-edit").classList.toggle("d-none");
        document.getElementById("interface-static").classList.toggle("d-none");
        document.getElementById("interface-edit").classList.toggle("d-none");
        document.getElementById("area-static").classList.toggle("d-none");
        document.getElementById("area-edit").classList.toggle("d-none");
        document.getElementById("status-static").classList.toggle("d-none");
        document.getElementById("status-edit").classList.toggle("d-none");
        if (document.getElementById("edit-basic-btn").innerText === "Edit"){
            document.getElementById("edit-basic-btn").innerText = "Cancel";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
            document.getElementById("name-edit").value = serverName;
            document.getElementById("interface-edit").value = interfaceId;
            document.getElementById("area-edit").value = areaId;
            document.getElementById("status-edit").value = isActive ? 1 : 0;
        }else{
            document.getElementById("edit-basic-btn").innerText = "Edit";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
        }
        formCheck("basic-form", "save-basic-btn");
    }

    function basicSubmit(){
        let nameX, areaIdX, interfaceIdX, productChange=false, nameChange=false, payload, configId, status;
        if (editRights){
            handleSubmitActions("save-basic-btn", "load-basic-btn");
            nameX = document.getElementById("name-edit").value;
            areaIdX = document.getElementById("area-edit").value;
            interfaceIdX = document.getElementById("interface-edit").value;
            configId = document.getElementById("siteNameId").value;
            status = document.getElementById("status-edit").value;
            if (interfaceId.toString() !== interfaceIdX.toString()){
                productChange = true;
            }
            if (serverName.toLowerCase() !== nameX.toLowerCase()){
                nameChange = true
            }
            // ip_address is not editable on this legacy form — pass through the
            // value read from the backend so server_edit does not clear it
            payload = [{area_id: parseInt(areaIdX), description: nameX, mac_addr: macAddr, config_id: parseInt(configId),
                        palcare_interface_id: parseInt(interfaceIdX), interface_change: productChange,
                        palcare_device_id: serverId, name_change: nameChange, is_active: parseInt(status),
                        ip_address: ipAddr}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "server_edit", Payload: payload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data && data[0]){
                    setRead(false);
                    setCount(0);
                    setPCount(0);
                    formSuccess("Basic information saved.", "save-basic-btn", "load-basic-btn",
                        "edit-basic-btn");
                }
                else{
                    formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                        "save-basic-btn", "load-basic-btn");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function basicDBSubmit(){
        let payload, serialOutPort, serialInPort, serialInId, serialOutId, serialInBaud, serialInBaudId,
            serialOutDelimiterId, serialOutBaud, serialInDelimiter, serialInDelimiterId, serialOutDelimiter,
            configTtlId, serialOutBaudId, configTtl, envOn, envOnId, sampleRate, sampleRateId, highTemp, highTempId,
            lowTemp, lowTempId, lowBat, lowBatId, resCheckin, resCheckinId, locCheckin, locCheckinId;
        if (editRights) {
            handleSubmitActions("editDBSubmit", "loadEditDBSubmit");
            serialInPort = document.getElementById("serialIn").value;
            serialInId = document.getElementById("serialInId").value;
            serialInBaud = document.getElementById("in_serial_baud").value;
            serialInBaudId = document.getElementById("in_serial_baud_id").value;
            serialInDelimiter = document.getElementById("in_serial_delimiter").value;
            serialInDelimiterId = document.getElementById("in_serial_delimiter_id").value;
            serialOutId = document.getElementById("serialOutId").value;
            serialOutPort = document.getElementById("serialOut").value;
            serialOutBaud = document.getElementById("out_serial_baud").value;
            serialOutBaudId = document.getElementById("out_serial_baud_id").value;
            serialOutDelimiter = document.getElementById("out_serial_delimiter").value;
            serialOutDelimiterId = document.getElementById("out_serial_delimiter_id").value;
            configTtl = document.getElementById("config_ttl").value;
            configTtlId = document.getElementById("config_ttl_id").value;
            envOn = document.getElementById("config_env_processing").checked;
            envOnId = document.getElementById("config_env_processing_id").value;
            sampleRate = document.getElementById("config_env_sample_rate").value;
            sampleRateId = document.getElementById("config_env_sample_rate_id").value;
            highTemp = document.getElementById("config_high_temp").value;
            highTempId = document.getElementById("config_high_temp_id").value;
            lowTemp = document.getElementById("config_low_temp").value;
            lowTempId = document.getElementById("config_low_temp_id").value;
            lowBat = document.getElementById("config_low_bat").value;
            lowBatId = document.getElementById("config_low_bat_id").value;
            resCheckin = document.getElementById("in_CheckinTime").value;
            resCheckinId = document.getElementById("in_CheckinTime_id").value;
            locCheckin = document.getElementById("config_inoLocCheckinTime").value;
            locCheckinId = document.getElementById("config_inoLocCheckinTime_id").value;
            payload = [{config_value: serialInPort, config_id: parseInt(serialInId), modified_by: dData.user},
                       {config_value: serialOutPort, config_id: parseInt(serialOutId), modified_by: dData.user},
                       {config_value: serialInBaud, config_id: parseInt(serialInBaudId), modified_by: dData.user},
                       {config_value: serialInDelimiter, config_id: parseInt(serialInDelimiterId), modified_by: dData.user},
                       {config_value: serialOutBaud, config_id: parseInt(serialOutBaudId), modified_by: dData.user},
                       {config_value: serialOutDelimiter, config_id: parseInt(serialOutDelimiterId), modified_by: dData.user},
                       {config_value: configTtl, config_id: parseInt(configTtlId), modified_by: dData.user},
                       {config_value: envOn ? "YES" : "NO", config_id: parseInt(envOnId), modified_by: dData.user},
                       {config_value: (parseInt(sampleRate) * 60).toString(), config_id: parseInt(sampleRateId), modified_by: dData.user},
                       {config_value: highTemp, config_id: parseInt(highTempId), modified_by: dData.user},
                       {config_value: lowTemp, config_id: parseInt(lowTempId), modified_by: dData.user},
                       {config_value: lowBat, config_id: parseInt(lowBatId), modified_by: dData.user},
                       {config_value: resCheckin, config_id: parseInt(resCheckinId), modified_by: dData.user},
                       {config_value: locCheckin, config_id: parseInt(locCheckinId), modified_by: dData.user}];
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_config", PKey: "config_id",
                            Condition: "primary", urlType: "POST", Payload: payload, User: dData.user,
                            CampusId: campusId, ClientId: dData.sessionId}).then(data => {
                if (data && data[0]){
                    setRead(false);
                    setPCount(0);
                    formSuccess("Server database updated.", "editDBSubmit", "loadEditDBSubmit",
                        "cancelEditDBBtn");
                }
                else{
                    formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                        "editDBSubmit", "loadEditDBSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }

    }

    function validateSubmit(mac){
        handleSubmitActions("validate-btn", "load-validate-btn");
        ApiRequester({reqEndpoint: "myvalidation", payload: {server_id: mac.replaceAll(":", ""),
                            campus_id: campusId, interface_id: interfaceId}, reqType: "validate"}).then(data => {
            setDbData(data);
            handleSubmitActions("load-validate-btn", "validate-btn");
        });
    }

    function fixDatabase(mac, missingConfigs, xtraConfigs){
        if (editRights){
            handleSubmitActions("validate-fix-btn", "load-validate-fix-btn");
            ApiRequester({reqEndpoint: "myvalidation", payload: {server_id: mac.replaceAll(":", ""),
                                campus_id: campusId, interface_id: interfaceId, config_items: missingConfigs,
                                config_extras: xtraConfigs}, reqType: "fix"}).then(data => {
                handleSubmitActions("load-validate-fix-btn", "validate-fix-btn");
                document.getElementById("validate-btn").click();
                setPCount(0);
            });
        }
    }

    function pingPEvents(mac){
        let msg;
        handleSubmitActions("local-btn", "load-local-btn");
        ApiRequester({reqEndpoint: "mqtt", Operation: "getActiveAlert", CampusId: campusId,
                            ClientId: dData.sessionId, ServerId: mac.replaceAll(":", "")}).then(data => {
            if(data[0]){
                setPCount(31);
                msg = "Interrogate successful, may take a moment to update.";
                formSuccess(msg, "local-btn", "load-local-btn");
            }
            else{
                msg = "Error interrogating server, contact support for assistance if error persists.";
                formFail(msg, "local-btn", "load-local-btn");
            }
        });
    }

    function editMatchModal(editIndex){
        let dataIndex, pattern, replacement, caseSensitive, area, device, ttl;
        if (editRights){
            dataIndex = parseInt(editIndex);
            setStoredMatchIndex(dataIndex);
            document.getElementById("matchterm_idE").value = matchActive[dataIndex]?.matchterm_id;
            pattern = document.getElementById("patternE");
            pattern.value = matchActive[dataIndex]?.pattern;
            caseSensitive = document.getElementById("iscaseE");
            caseSensitive.checked = matchActive[dataIndex]?.is_case_sensitive === 1;
            if ([1,2,3].includes(matchActive[dataIndex]?.match_type_id)){ // CREATE, REPEAT, CLEAR *
                document.getElementById("c-replacementE").classList.add("d-none");
                document.getElementById("c-area_idE").classList.add("d-none");
                document.getElementById("c-device_idE").classList.add("d-none");
                document.getElementById("c-event_cat_idE").classList.remove("d-none");
                document.getElementById("c-event_type_idE").classList.remove("d-none");
                document.getElementById("c-ttlE").classList.remove("d-none");
                document.getElementById("area_idE").required = false;
                document.getElementById("device_idE").required = false;
                document.getElementById("patternE").required = false;
                ttl = document.getElementById("ttlE")
                ttl.value = matchActive[dataIndex]?.ttl / 60
            }else if (matchActive[dataIndex]?.match_type_id === 4){ // IGNORE *
                document.getElementById("c-replacementE").classList.add("d-none");
                document.getElementById("c-area_idE").classList.add("d-none");
                document.getElementById("c-device_idE").classList.add("d-none");
                document.getElementById("c-event_cat_idE").classList.add("d-none");
                document.getElementById("c-event_type_idE").classList.add("d-none");
                document.getElementById("c-ttlE").classList.add("d-none");
                document.getElementById("area_idE").required = false;
                document.getElementById("device_idE").required = false;
                document.getElementById("patternE").required = true;
            }else if (matchActive[dataIndex]?.match_type_id === 5){ // CHANGE *
                document.getElementById("c-event_cat_idE").classList.add("d-none");
                document.getElementById("c-event_type_idE").classList.add("d-none");
                document.getElementById("c-area_idE").classList.add("d-none");
                document.getElementById("c-device_idE").classList.add("d-none");
                document.getElementById("c-replacementE").classList.remove("d-none");
                document.getElementById("c-ttlE").classList.add("d-none");
                document.getElementById("area_idE").required = false;
                document.getElementById("device_idE").required = false;
                document.getElementById("patternE").required = false;
                replacement = document.getElementById("replacementE");
                replacement.value = matchActive[dataIndex]?.replacement;
            }else if (matchActive[dataIndex]?.match_type_id === 6){ // AREA *
                document.getElementById("c-event_cat_idE").classList.add("d-none");
                document.getElementById("c-event_type_idE").classList.add("d-none");
                document.getElementById("c-device_idE").classList.add("d-none");
                document.getElementById("c-replacementE").classList.add("d-none");
                document.getElementById("c-area_idE").classList.remove("d-none");
                document.getElementById("c-ttlE").classList.add("d-none");
                document.getElementById("area_idE").required = true;
                document.getElementById("device_idE").required = false;
                document.getElementById("patternE").required = false;
                area = document.getElementById("area_idE");
                area.value = matchActive[dataIndex]?.area_id;
            }else if (matchActive[dataIndex]?.match_type_id === 7){ // DEVICE *
                document.getElementById("c-event_cat_idE").classList.add("d-none");
                document.getElementById("c-event_type_idE").classList.add("d-none");
                document.getElementById("c-area_idE").classList.add("d-none");
                document.getElementById("c-replacementE").classList.add("d-none");
                document.getElementById("c-device_idE").classList.remove("d-none");
                document.getElementById("c-ttlE").classList.add("d-none");
                document.getElementById("area_idE").required = false;
                document.getElementById("device_idE").required = true;
                document.getElementById("patternE").required = false;
                device = document.getElementById("device_idE");
                device.value = matchActive[dataIndex]?.device_id;
            }
            formCheck("editMatchForm", "editMatchSubmit");
            showModal("editmatchmodal");
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formEditMatchSubmit(){
        let dataIndex, pattern, replacement, caseSensitive, areaId, payload = [], eCatId, eTypeId, termId, ttl,
            deviceId;
        if (editRights){
            handleSubmitActions("editMatchSubmit", "loadEditMatchSubmit");
            dataIndex = parseInt(storedMatchIndex);
            termId = document.getElementById("matchterm_idE").value;
            pattern = document.getElementById("patternE").value;
            caseSensitive = document.getElementById("iscaseE").checked;
            if ([1,2,3].includes(matchActive[dataIndex]?.match_type_id)){
                eCatId = document.getElementById("event_cat_idE").value;
                eTypeId = document.getElementById("event_type_idE").value;
                ttl = document.getElementById("ttlE").value;
                payload.push({matchterm_id: parseInt(termId), pattern: pattern, is_case_sensitive: caseSensitive ? 1 : 0,
                              event_category_id: parseInt(eCatId), event_type_id: parseInt(eTypeId),
                              ttl: parseInt(ttl)*60, modified_by: dData.user});
            }else if (matchActive[dataIndex]?.match_type_id === 4){
                payload.push({matchterm_id: parseInt(termId), pattern: pattern,
                              is_case_sensitive: caseSensitive ? 1 : 0, modified_by: dData.user});
            }else if (matchActive[dataIndex]?.match_type_id === 5){
                replacement = document.getElementById("replacementE");
                payload.push({matchterm_id: parseInt(termId), pattern: pattern, replacement: replacement,
                              is_case_sensitive: caseSensitive ? 1 : 0, modified_by: dData.user});
            }else if (matchActive[dataIndex]?.match_type_id === 6){
                areaId = document.getElementById("area_idE").value;
                payload.push({matchterm_id: parseInt(termId), pattern: pattern, area_id: parseInt(areaId),
                              is_case_sensitive: caseSensitive ? 1 : 0, modified_by: dData.user});
            }else if (matchActive[dataIndex]?.match_type_id === 7){
                const deviceSelect = document.getElementById("device_idE");
                replacement = deviceSelect.options[deviceSelect.selectedIndex].innerText;
                deviceId = deviceSelect.value;
                payload.push({matchterm_id: parseInt(termId), pattern: pattern, replacement: replacement,
                              is_case_sensitive: caseSensitive ? 1 : 0, modified_by: dData.user, device_id: parseInt(deviceId)})
            }
            if (payload.length > 0){
                ApiRequester({reqEndpoint: "mysave", Tbl: "core_matchterm", Payload: payload, urlType: "POST", User: dData.user,
                                PKey: "matchterm_id", Condition: "primary", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
                    if (data[0]){
                        setICount(0);
                        setMatchIdList([]);
                        formSuccess("Match terms updated successfully", "editMatchSubmit",
                            "loadEditMatchSubmit", "cancelMatchEditBtn", "editMatchForm");
                    }
                    else{
                        formFail(`Failed to add new match term: ${data[1]}`, "editMatchSubmit", "loadEditMatchSubmit");
                    }
                });
            }else{
                toast.warn("No valid payload constructed, check items for validity.");
                handleSubmitActions("loadEditMatchSubmit", "editMatchSubmit");
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formAddMatchSubmit(){
        let pattern1, pattern2, pattern3, replacement, caseSensitive, payload = [],
            eCatId, eTypeId, ttl;
        if (editRights){
            handleSubmitActions("addMatchSubmit", "loadAddMatchSubmit");
            if (addMatchTypeId === 1){
                pattern1 = document.getElementById("create_pattern").value;
                pattern2 = document.getElementById("repeat_pattern").value;
                pattern3 = document.getElementById("clear_pattern").value;
                eCatId = document.getElementById("add-event-cat-id").value;
                eTypeId = document.getElementById("add-event-type-id").value;
                caseSensitive = document.getElementById("add-iscase1").checked;
                ttl = document.getElementById("add-ttl").value;
                if (pattern1 !== ""){
                    payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: pattern1,
                                  replacement: "", match_type_id: 1, is_case_sensitive: 1 ? caseSensitive : 0,
                                  area_id: 0, device_id: 0, event_category_id: parseInt(eCatId),
                                  event_type_id: parseInt(eTypeId), ttl: parseInt(ttl)*60, modified_by: dData.user});
                }
                if (pattern2 !== ""){
                    payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: pattern2,
                                  replacement: "", match_type_id: 2, is_case_sensitive: 1 ? caseSensitive : 0,
                                  area_id: 0, device_id: 0, event_category_id: parseInt(eCatId),
                                  event_type_id: parseInt(eTypeId), ttl: parseInt(ttl)*60, modified_by: dData.user});
                }
                if (pattern3 !== ""){
                    payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: pattern3,
                                  replacement: "", match_type_id: 3, is_case_sensitive: 1 ? caseSensitive : 0,
                                  area_id: 0, device_id: 0, event_category_id: parseInt(eCatId),
                                  event_type_id: parseInt(eTypeId), ttl: parseInt(ttl)*60, modified_by: dData.user});
                }
                if (payload.length <= 0){
                    toast.warn("No trigger patterns filled out, nothing to add.");
                }
            }else if (addMatchTypeId === 2){
                pattern1 = document.getElementById("add-pattern2").value;
                replacement = document.getElementById("add-replacement2").value;
                caseSensitive = document.getElementById("add-iscase2").checked;
                if (![undefined, null, ""].includes(pattern1)){
                    payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: pattern1,
                                  replacement: replacement, match_type_id: 5, is_case_sensitive: 1 ? caseSensitive : 0,
                                  area_id: 0, device_id: 0, event_category_id: 0,
                                  event_type_id: 0, ttl: 0, modified_by: dData.user})
                }else{
                    toast.warn("No pattern to capture on.");
                }
            }else if (addMatchTypeId === 3){
                caseSensitive = document.getElementById("add-iscase3").checked;
                for (let i=0; i < matchAreaMap.length; i++){
                    if (matchAreaMap[i].type === 1){
                        payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: matchAreaMap[i].pattern,
                                      replacement: "", match_type_id: 6, is_case_sensitive: 1 ? caseSensitive : 0,
                                      area_id: parseInt(matchAreaMap[i].replacement), device_id: 0,
                                      event_category_id: 0, event_type_id: 0, ttl: 0, modified_by: dData.user});
                    }else{
                        payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: matchAreaMap[i].pattern,
                                      replacement: matchAreaMap[i].replacement, match_type_id: 6,
                                      is_case_sensitive: 1 ? caseSensitive : 0, area_id: 0, device_id: 0,
                                      event_category_id: 0, event_type_id: 0, ttl: 0, modified_by: dData.user});
                    }
                }
            }else if (addMatchTypeId === 4){
                caseSensitive = document.getElementById("add-iscase4").checked;
                for (let i=0; i < matchDeviceMap.length; i++){
                    if (matchDeviceMap[i].type === 1){
                        payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: matchDeviceMap[i].pattern,
                                      replacement: "", match_type_id: 7, is_case_sensitive: 1 ? caseSensitive : 0,
                                      area_id: 0, device_id: parseInt(matchDeviceMap[i].replacement),
                                      event_category_id: 0, event_type_id: 0, ttl: 0, modified_by: dData.user});
                    }else{
                        payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: matchDeviceMap[i].pattern,
                                      replacement: matchDeviceMap[i].replacement, match_type_id: 7,
                                      is_case_sensitive: 1 ? caseSensitive : 0, area_id: 0, device_id: matchDeviceMap[i].device_id,
                                      event_category_id: 0, event_type_id: 0, ttl: 0, modified_by: dData.user});
                    }
                }
            }else if (addMatchTypeId === 5){
                pattern1 = document.getElementById("add-pattern5").value;
                caseSensitive = document.getElementById("add-iscase5").checked;
                if (pattern1 !== ""){
                    payload.push({campus_id: campusId, palcare_device_id: serverId, pattern: pattern1,
                                  replacement: "", match_type_id: 4, is_case_sensitive: 1 ? caseSensitive : 0,
                                  area_id: 0, device_id: 0, event_category_id: 0, event_type_id: 0, ttl: 0,
                                  modified_by: dData.user})
                }else{
                    toast.warn("No valid pattern entered. Unable to add.");
                }
            }else{
                toast.warn("Invalid type for add");
            }
            if (payload.length > 0){
                ApiRequester({reqEndpoint: "mysave", Tbl: "core_matchterm", Payload: payload, urlType: "PUT",
                                    User: dData.user, PKey: "matchterm_id", Condition: "primary", CampusId: campusId,
                                    ClientId: dData.sessionId}).then(data => {
                    if (data[0]){
                        setICount(0);
                        setMatchIdList([]);
                        setMatchDeviceMap([]);
                        setMatchAreaMap([]);
                        formSuccess("Match terms added successfully", "addMatchSubmit",
                            "loadAddMatchSubmit", "cancelAddMatchBtn", "addMatchForm");
                    }
                    else{
                        formFail(`Failed to add new match terms: ${data[1]}`, "addMatchSubmit", "loadAddMatchSubmit");
                    }
                });
            }else{
                handleSubmitActions("loadAddMatchSubmit", "addMatchSubmit");
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formAddVirtualDeviceSubmit(){
        let payload = [], devices, deviceName, deviceTypeName;
        if (editRights){
            handleSubmitActions("addVirtualSubmit", "loadAddVirtualSubmit");
            devices = Array.from(document.getElementsByName("virtualdeviceadd"));
            for (let i=0; i < devices.length; i++) {
                if (devices[i].checked){
                    const deviceTypeId = parseInt(devices[i].value);
                    const deviceType = virtualDeviceTypeData.find((vType) => vType.device_type_id === deviceTypeId);
                    deviceTypeName = deviceType?.device_type_name || "";
                    deviceName = document.getElementById(`v-device-name-${devices[i].value}`).value;
                    payload.push({campus_id: dData.acnt, is_active: 1, resident_id: 0, area_id: 0, is_area_device: 1,
                                  device_name: deviceName !== "" ? deviceName : deviceTypeName, manufacture_id: 9,
                                  descriptions: "", device_type_id: deviceTypeId, manufacture_uuid: ""})
                }
            }
            if (payload.length > 0){
                ApiRequester({reqEndpoint: "mysave", Tbl: "core_device", Payload: payload, urlType: "PUT", User: dData.user,
                            PKey: "device_id", Condition: "primary", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
                    if (data[0]){
                        setICount(0);
                        formSuccess("Virtual devices added", "addVirtualSubmit",
                            "loadAddVirtualSubmit", "cancelAddVirtualBtn", "addVirtualForm");
                    }
                    else{
                        formFail(`Failed to add new match term: ${data[1]}`, "AddVirtualSubmit", "loadAddVirtualSubmit");
                    }
                });
            }else{
                handleSubmitActions("loadAddVirtualSubmit", "addVirtualSubmit");
                toast.warn("No valid devices selected")
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deleteMatchPerform(submitBtn, loadBtn, closeId, start, end){
        let payload = [];
        if (editRights){
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent.length; i++){
                payload.push({matchterm_id: dContent[i][0], modified_by: dData.user});
            }
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_matchterm", Payload: payload, urlType: "DELETE", User: dData.user,
                                PKey: "matchterm_id", Condition: "primary", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setICount(0);
                    setMatchIdList([]);
                    formSuccess("Match terms deleted successfully", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteBtn"]);
                }
                else{
                    formFail(`Failed to delete with error: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deleteVirtualPerform(submitBtn, loadBtn, closeId, start, end){
        let payload = [];
        if (editRights){
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent.length; i++){
                payload.push({device_id: dContent[i][0], modified_by: dData.user});
            }
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_device", Payload: payload, urlType: "DELETE", User: dData.user,
                                PKey: "device_id", Condition: "primary", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setICount(0);
                    setVirtualIdList([]);
                    formSuccess("Virtual device deleted", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckVirtualHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteVirtualBtn"]);
                }
                else{
                    formFail(`Failed to delete with error: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deviceMapUpdater() {
        // This function is triggered from the phone number add modal save which takes the current phone numbers
        // display items and then new numbers display items and sets those values into their appropriate output
        // entity holder text or voice.
        let tmp = [];
        for (let i = 0; i < matchDeviceMap.length; i++) {
            tmp.push(matchDeviceMap[i]);
        }
        for (let i2 = 0; i2 < tmpDeviceMap.length; i2++) {
            tmp.push(tmpDeviceMap[i2]);
        }
        setMatchDeviceMap(() => tmp);
        document.getElementById("cancelDeviceMapBtn").click();
    }

    function areaMapUpdater() {
        // This function is triggered from the phone number add modal save which takes the current phone numbers
        // display items and then new numbers display items and sets those values into their appropriate output
        // entity holder text or voice.
        let tmp = [];
        for (let i = 0; i < matchAreaMap.length; i++) {
            tmp.push(matchAreaMap[i]);
        }
        for (let i2 = 0; i2 < tmpAreaMap.length; i2++) {
            tmp.push(tmpAreaMap[i2]);
        }
        setMatchAreaMap(() => tmp);
        document.getElementById("cancelAreaMapBtn").click();
    }

    function filterSubmit() {
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        dData.perPage = tmpPerPage;
        setLogPage(1);
        setSession(dData);
        formSuccess("Page parameters stored to session.", "filterSubmit",
            "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    const tableHeaders = (<TableHeaders checkbox={false} headerData={serverHeaderData} checkAll={() => {}}
                                        writeAccess={false} sortOrder={sorter.sortOrder}
                                        sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter}
                                        modal={false} checkboxlist={[]} actionAppearance={() => {}}/>);

    const matchTermsHeaders = (<TableHeaders checkbox={editRights} headerData={matchHeaderData}
                                             checkAll={() => checkAll(ppRules2.start, ppRules2.end, matchIdList, setMatchIdList)}
                                             writeAccess={editRights} sortOrder={sorter2.sortOrder} modal_name={"Edit"}
                                             sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2}
                                             modal={true} checkboxlist={matchIdList} checkboxHeaderId={"uCheckHead"}
                                             actionAppearance={() => actionAppearance(ppRules2.start, ppRules2.end, ["deleteBtn"])} />);
    const logTableHeaders = <TableHeaders checkbox={false} headerData={logHeaderData} checkAll={() => {}}
                                          writeAccess={false} sortOrder={logSorter.sortOrder} modal_name={""}
                                          originData={logOriginData} headerFiltersOn={true}
                                          sortColumn={logSorter.sortColumn} sorter={logSorter} setSorter={setLogSorter}
                                          modal={false} checkboxlist={[]} actionAppearance={() => {}}
                                          headerFilters={logHeaderFilters} setHeaderFilters={setLogHeaderFilters} setPage={setLogPage}/>
    const virtualTableHeaders = <TableHeaders checkbox={editRights} headerData={virtualDeviceHeaderData}
                                        checkAll={() => checkAll(0, virtualDeviceData.length, virtualIdList, setVirtualIdList, "uCheckVirtualHead", "uCheckVirtual")}
                                       writeAccess={editRights} checkboxHeaderId={"uCheckVirtualHead"} headerFiltersOn={false}
                                       modal={false} checkboxlist={virtualIdList}
                                       actionAppearance={() => actionAppearance(0, virtualDeviceData.length, ["deleteVirtualBtn"], "uCheckVirtual")} modal_name={""} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
        </div>
    );

    const subTitleJsx = dData?.campusData[dData?.acnt.toString()]?.is_cloud
        ? (<>
            <p className={"mb-0 me-3"} style={{
                   width: "20px",
                   height: "20px",
                   borderRadius: "50%",
                   position: "relative",
                   display: "inline-block",
                   backgroundColor: isOffline === null ? "var(--color-text-secondary)" : (isOffline ? "#ff4053" : "#24be74"),
                   boxShadow: isOffline === null
                       ? "0 0 0 2px rgba(108, 117, 125, 0.15), 0 0 0 4px rgba(108, 117, 125, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.15)"
                       : (isOffline
                           ? "0 0 0 2px rgba(220, 53, 69, 0.15), 0 0 0 4px rgba(220, 53, 69, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.15)"
                           : "0 0 0 2px rgba(25, 135, 84, 0.15), 0 0 0 4px rgba(25, 135, 84, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.2)"),
                   border: isOffline === null
                       ? "1px solid rgba(108, 117, 125, 0.25)"
                       : (isOffline
                           ? "1px solid rgba(220, 53, 69, 0.25)"
                           : "1px solid rgba(25, 135, 84, 0.25)"),
                   animation: "none",
                   textAlign: "center"
               }}></p>
            <p className={isOffline !== null ? isOffline ? "text-danger" : "text-success" : ""}>
                {isOffline === null ? "Unknown Online Status" : isOffline ? "Server Offline" : "Server Online"}
            </p>
        </>)
        : <></>

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Server Profile"} Title={serverName} content={headerContent} subTitle={subTitleJsx}/>
                <div className={"container-fluid"}>
                    <div className={"col"}>
                        <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                            <li key={"set-basic"} className={"nav-item"}>
                                <Button text={"Basic Info"} class={tabItem === "basic" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("basic")}/>
                            </li>
                            <li key={"set-database"} className={"nav-item"}>
                                <Button text={"Database"}
                                        class={tabItem === "database" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("database")}/>
                            </li>
                            {[1, 2].includes(interfaceId)
                                ? <li key={"set-match"} className={"nav-item"}>
                                    <Button text={"Match Terms"}
                                            class={tabItem === "match" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("match")}/>
                                </li>
                                : <></>
                            }
                            {dData?.campusData[dData?.acnt.toString()]?.is_cloud
                                ?   <li key={"set-logs"} className={"nav-item"}>
                                        <Button text={"Server Logs"}
                                                class={tabItem === "logs" ? "nav-link active" : "nav-link"}
                                                onClick={() => setTabItem("logs")}/>
                                    </li>
                                :   <></>
                            }
                            <li key={"set-debug"} className={"nav-item"}>
                                <Button text={"Troubleshooting"}
                                        class={tabItem === "debug" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("debug")}/>
                            </li>
                        </ul>
                    </div>
                    <div className={tabItem === "basic" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "550px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}>Basic Information</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"basic-card-btn"}
                                       onClick={() => toggleCollapse("basic-card-btn", "basic-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"basic-card"}>
                                <form className={"d-inline align-top form-control-plaintext was-validated"}
                                      id={"basic-form"}>
                                    <div className={"d-flex justify-content-start"}>
                                        <div className={"mx-5 mt-2 align-top d-inline-block"} id={"basic-col1-div"}
                                             style={{minWidth: "375px"}}>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>Description:</p>
                                                <p className={"ms-4"} id={"name-static"}>{serverName}</p>
                                                <input className={"ms-4 d-none form-control form-control-sm"}
                                                       required={true}
                                                       onKeyUp={() => formCheck("basic-form", "save-basic-btn")}
                                                       style={{height: "30px", width: "225px"}} id={"name-edit"}
                                                       defaultValue={serverName} pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                                <input type={"hidden"} id={"siteNameId"}/>
                                            </div>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>MAC:</p>
                                                <p className={"ms-4"} id={"mac-static"}>{macAddr}</p>
                                            </div>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>Product Interface:</p>
                                                <p className={"ms-4"} id={"interface-static"}>{interfaceName}</p>
                                                <select className={"ms-4 d-none form-select form-select-sm"}
                                                        onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                        style={{height: "30px", width: "225px"}} id={"interface-edit"}
                                                        defaultValue={interfaceId}>
                                                    <option value={3}>Inovonics</option>
                                                    <option value={1}>Hard-Wired</option>
                                                    <option value={2}>Firepanel</option>
                                                </select>
                                            </div>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>Hardware:</p>
                                                <p className={"ms-4"} id={"hardware-static"}>{hardware}</p>
                                            </div>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>System OS:</p>
                                                <p className={"ms-4"} id={"os-static"}>{os}</p>
                                            </div>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>Local IP:</p>
                                                <p className={"ms-4"} id={"os-static"}>{ipAddr}</p>
                                            </div>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>Implementation:</p>
                                                <p className={"ms-4"}
                                                   id={"status-static"}>{isActive ? "Main" : "Backup"}</p>
                                                <select className={"ms-4 d-none form-select form-select-sm"}
                                                        onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                        style={{height: "30px", width: "225px"}} id={"status-edit"}
                                                        defaultValue={isActive}>
                                                    <option value={1}>Main</option>
                                                    <option value={0}>Backup</option>
                                                </select>
                                            </div>
                                            <div className={"d-flex"}>
                                                <p style={{minWidth: "125px"}}>Area:</p>
                                                <p className={"ms-4"} id={"area-static"}>
                                                    <Link to={`/profiles/area/${areaId}`}>{areaName}</Link>
                                                </p>
                                                <select className={"ms-4 d-none form-select form-select-sm"}
                                                        onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                        style={{height: "30px", width: "225px"}} id={"area-edit"}
                                                        defaultValue={areaId}>
                                                    {locationOptions}
                                                </select>
                                            </div>
                                        </div>
                                        <div className={"mx-5 mt-2 align-top d-inline-block"} id={"basic-col2-div"}>
                                            <div>
                                                <div className={"d-flex"}>
                                                    <p style={{minWidth: "125px"}}>Last Heartbeat:</p>
                                                    <p className={"ms-4"} id={"lastAlarm-static"}>{lastHeartbeat}</p>
                                                </div>
                                                <div className={"d-flex"}>
                                                    <p style={{minWidth: "125px"}}>Last Alarm:</p>
                                                    <p className={"ms-4"} id={"lastAlarm-static"}>{recentAlarmTime}</p>
                                                </div>
                                                <div className={"d-flex"}>
                                                    <p style={{minWidth: "125px"}}>Active Alarms:</p>
                                                    <p className={"ms-4"}
                                                       id={"activeCount-static"}>{activeAlarmsCount}</p>
                                                </div>
                                                <div className={"d-flex"}>
                                                    <p style={{minWidth: "125px"}}>Last Rebooted:</p>
                                                    <p className={"ms-4"} id={"lastReboot-static"}>{lastReboot}</p>
                                                </div>
                                                <div className={"d-flex"}>
                                                    <p style={{minWidth: "125px"}}>Uptime (Hrs):</p>
                                                    <p className={"ms-4"} id={"uptime-static"}>{uptime}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"ms-auto"}>
                                            {pageLoaded && editRights
                                                ?   <>
                                                        <Button text={"Edit"} class={"btn btn-primary float-end mt-1"}
                                                                id={"edit-basic-btn"}
                                                                disabled={!editRights} onClick={() => {
                                                            if (editRights) {
                                                                basicActionHandling();
                                                            }
                                                        }}/>
                                                        <Button text={"Save"}
                                                                class={"btn btn-primary float-end mt-1 me-3 d-none"}
                                                                id={"save-basic-btn"}
                                                                disabled={!editRights} onClick={() => {
                                                            if (editRights) {
                                                                basicSubmit();
                                                            }
                                                        }}/>
                                                        <Button type={"button"}
                                                                class={"btn btn-primary float-end mt-1 mx-3 d-none"}
                                                                disabled={true}
                                                                spinner={true} text={""} id={"load-basic-btn"}/>
                                                    </>
                                                :   <></>
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "database" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}
                                        style={{minWidth: "80px"}}>Database</h3>
                                    <div className={"d-none"} style={{display: "inline-block"}} id={"db-header-data"}>
                                        {dbValid !== null
                                            ? dbValid?.valid
                                                ? <><h3 className={"ms-6 my-0 d-inline-block text-success"}>Database
                                                    Exists <i className={"fe fe-check-circle text-success"}></i></h3></>
                                                : <><h3 className={"ms-6 my-0 d-inline-block text-danger"}>Database
                                                    Missing <i className={"fe fe-alert-octagon text-danger"}></i>
                                                </h3></>
                                            : <></>
                                        }
                                        <h3 className={"ms-6 my-0 d-inline-block text-success"}></h3>
                                    </div>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"db-card-btn"}
                                       onClick={() => {
                                           toggleCollapse("db-card-btn", "db-card");
                                           document.getElementById("db-header-data").classList.toggle("d-none");
                                       }}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"db-card"}
                                 style={{maxHeight: "650px", overflowY: "auto"}}>
                                <div>
                                    {dbValid !== null
                                        ? dbValid?.valid
                                            ? <>
                                                <div className={"d-inline-block"}>
                                                    <h3 className={"text-success"}>Database Exists
                                                        <i className={"fe fe-check-circle text-success"}></i>
                                                    </h3>
                                                    <Button text={"Validate DB"} class={"btn btn-primary mt-2"}
                                                            id={"validate-btn"} onClick={() => {
                                                        validateSubmit(macAddr);
                                                    }}/>
                                                    <Button type={"button"} class={"btn btn-primary mt-2 d-none"}
                                                            disabled={true} spinner={true} text={"Validating"}
                                                            id={"load-validate-btn"}/>
                                                </div>
                                                {dbData?.validated
                                                    ? (dbData?.missing?.length > 0 || dbData?.extras?.length > 0) && editRights
                                                        ? <div className={"d-inline-block"}>
                                                            <Button text={"Fix DB"} class={"btn btn-primary mt-2"}
                                                                    id={"validate-fix-btn"} icon={true}
                                                                    iconType={"google"}
                                                                    iconClass={"material-icons md-18 md-dark me-2 align-text-bottom"}
                                                                    iconSize={"tiny"} iconColor={"#FFFFFF"}
                                                                    iconName={"handyman"} onClick={() => {
                                                                fixDatabase(macAddr, dbData?.missing ? dbData.missing : [],
                                                                    dbData?.extras ? dbData.extras : []);
                                                            }}/>
                                                            <Button type={"button"}
                                                                    class={"btn btn-primary mt-2 d-none"}
                                                                    disabled={true} spinner={true} text={"Fixing"}
                                                                    id={"load-validate-fix-btn"}/>
                                                        </div>
                                                        : <></>
                                                    : <></>
                                                }
                                                {editRights
                                                    ?   <div className={"d-inline"} style={{verticalAlign: "top"}}>
                                                            <Button text={"Edit"} class={"btn btn-primary float-end"}
                                                                    id={"edit-db-btn"} disabled={!editRights}
                                                                    onClick={() => {
                                                                        if (editRights) {
                                                                            editDBModal();
                                                                        }
                                                                    }}/>
                                                        </div>
                                                    :   <></>
                                                }
                                            </>
                                            : <div><h3 className={"text-danger"}>Database Missing <i
                                                className={"fe fe-alert-octagon text-danger"}></i></h3></div>
                                        : <></>
                                    }
                                </div>
                                <div className={"mt-4"}>
                                    {dbData?.validated
                                        ? dbData?.missing?.length > 0
                                            ? <h4 className={"text-danger"}>Database Invalid:</h4>
                                            : <h4 className={"text-success"}>Database Valid</h4>
                                        : <></>
                                    }
                                    <ul style={{listStyle: "none"}}>
                                        {dbData?.missing?.map((missingRec, i) => {
                                            return (
                                                <li key={`missing-${i}`} className={"text-danger"}>{missingRec} -
                                                    Missing
                                                    Requirement</li>);
                                        })}
                                        {dbData?.extras?.map((extraRec, i) => {
                                            return (
                                                <li key={`extras-${i}`} className={"text-warning"}>{extraRec} - Warning
                                                    extra config</li>);
                                        })}
                                        {dbData?.dupes?.map((dupeRec, i) => {
                                            return (
                                                <li key={`dupes-${i}`} className={"text-warning"}>{dupeRec} - Warning
                                                    duplicate config</li>);
                                        })}
                                    </ul>
                                </div>
                                <div>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 mb-3"}>
                                        <input type={"search"} id={"search1"}
                                               className={"form-control search-input mt-1"}
                                               onKeyUp={(e) => setSearch(e.target.value)}/>
                                        <Button text={""} type={"button"}
                                                class={"btn btn-primary smooth-radius-left mt-1"}
                                                style={{height: "42px"}}
                                                icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div>
                                        {dbValid !== null
                                            ? <>
                                                <table className={"table table-sm table-white table-hover"}>
                                                    <thead className={"sticky-table-head"} style={{top: "-25px"}}>
                                                    {tableHeaders}
                                                    </thead>
                                                    <tbody id={"tBody"}>
                                                    {serverTableRows}
                                                    </tbody>
                                                </table>
                                                <div className={"text-center"}>
                                                    <Pagination>
                                                        <PaginationItems setPage={setPage} page={page}
                                                                         beginDot={ppRules.beginDot}
                                                                         endDot={ppRules.endDot}
                                                                         pageMin={ppRules.pageMin}
                                                                         pageMax={ppRules.pageMax}
                                                                         max={ppRules.max}/>
                                                    </Pagination>
                                                </div>
                                            </>
                                            : <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "logs" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}
                                        style={{minWidth: "80px"}}>Device Logs</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"wellness-card-btn"}
                                       onClick={() => toggleCollapse("logs-card-btn", "logs-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"logs-card"}>
                                <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {logTableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                    {logTableRows}
                                    </tbody>
                                </table>
                                <div className={"text-center"}>
                                    <Pagination>
                                        <PaginationItems setPage={setLogPage} page={logPage}
                                                         beginDot={logPPRules.beginDot}
                                                         endDot={logPPRules.endDot} pageMin={logPPRules.pageMin}
                                                         pageMax={logPPRules.pageMax}
                                                         max={logPPRules.max}/>
                                    </Pagination>
                                    <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage}
                                            onClick={() => showModal("filtermodal")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "debug" ? "d-block" : "d-none"}>
                        {interfaceId === 3
                            ? <>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>Server Status</h3>
                                            <div className={"d-none"} style={{display: "inline-block"}}
                                                 id={"status-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>{deviceData.length} Statuses</h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-minus as-btn collapse-toggle p-2"}
                                               id={"status-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("status-card-btn", "status-card");
                                                   document.getElementById("status-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content show"} id={"status-card"}
                                         style={{maxHeight: "650px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-responsive-sm table-hover"}>
                                            <thead className={"table-header"}>
                                            <tr>
                                                <td className={"text-center"}>Process Count</td>
                                                <td className={"text-center"}>Aggregate Count</td>
                                                <td className={"text-center"}>Eman Count</td>
                                                <td className={"text-center"}>Maint. Count</td>
                                                <td className={"text-center"}>Other Count</td>
                                                <td className={"text-center"}>Alarm Time</td>
                                                <td className={"text-center"}>Alarm Msg Raw/Parsed</td>
                                                <td className={"text-center"}>Last Updated</td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {deviceData.map((device, i) => {
                                                return <tr key={`device-count-row-${i}`}>
                                                    <td className={"text-center"}>{device?.count_process_queue}</td>
                                                    <td className={"text-center"}>{device?.count_aggregate_repeater_queue}</td>
                                                    <td className={"text-center"}>{device?.count_eman_event_queue}</td>
                                                    <td className={"text-center"}>{device?.count_maint_queue}</td>
                                                    <td className={"text-center"}>{device?.count_other_queue}</td>
                                                    <td className={"text-center"}>{device?.recent_alarm_input_time}</td>
                                                    <td className={"text-center"}>
                                                        <MaterialIcon className={"material-icons as-btn-2x me-2"}
                                                                      onClick={() => {
                                                                          toast.info(device?.recent_alarm_input_raw);
                                                                          navigator?.clipboard?.writeText(device?.recent_alarm_input_raw);
                                                                      }}
                                                                      icon={"raw_on"}
                                                                      title={device?.recent_alarm_input_raw}/>
                                                        <MaterialIcon className={"material-icons as-btn-2x"}
                                                                      onClick={() => {
                                                                          toast.info(device?.recent_alarm_input_parsed);
                                                                          navigator?.clipboard?.writeText(device?.recent_alarm_input_parsed);
                                                                      }}
                                                                      icon={"data_object"}
                                                                      title={device?.recent_alarm_input_parsed}/>
                                                    </td>
                                                    <td className={"text-center"}>{device?.modify_time}</td>
                                                </tr>
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                            : <></>
                        }
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}
                                        style={{minWidth: "80px"}}>Local Alerts</h3>
                                    <div style={{display: "inline-block"}} id={"local-header-data"}>
                                        <h3 className={"ms-6 my-0 d-inline-block text-success"}>{localData?.length} Alerts</h3>
                                    </div>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"local-card-btn"}
                                       onClick={() => {
                                           toggleCollapse("local-card-btn", "local-card");
                                           document.getElementById("local-header-data").classList.toggle("d-none");
                                       }}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"local-card"}>
                                <Button text={"Local Alerts"} icon={true} iconClass={"fe fe-loader me-2"}
                                        class={"btn btn-primary mt-2"} id={"local-btn"}
                                        onClick={() => {
                                            pingPEvents(macAddr);
                                        }}/>
                                <Button type={"button"} class={"btn btn-primary mt-2 d-none"} disabled={true}
                                        spinner={true} text={"Interrogating"} id={"load-local-btn"}/>
                                <table className={"table table-sm table-responsive-sm table-hover mt-4"}>
                                    <thead className={"table-header"}>
                                    <tr>
                                        <th className={"text-center"}>Event Date Time</th>
                                        <th className={"text-center"}>Alert Category</th>
                                        <th className={"text-center"}>Alert Type</th>
                                        <th className={"text-center"}>Area Name</th>
                                        <th className={"text-center"}>Device Name</th>
                                        <th className={"text-center"}>Serial Number</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {localData.map((pEvent, i) => {
                                        let jsonObj = JSON.parse(pEvent?.event_json ? pEvent.event_json : '{}')
                                        return <tr key={`local-alert-${i}`}>
                                            <td className={"text-center"}>{jsonObj?.eventDateTime}</td>
                                            <td className={"text-center"}>{jsonObj?.type}</td>
                                            <td className={"text-center"}>{jsonObj?.sType}</td>
                                            <td className={"text-center"}>{jsonObj?.location?.name}</td>
                                            <td className={"text-center"}>{jsonObj?.device?.name}</td>
                                            <td className={"text-center"}>{jsonObj?.device?.serialNum}</td>
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {[1, 2].includes(interfaceId)
                        ? <>
                            <div className={tabItem === "match" ? "d-block" : "d-none"}>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>Match Terms</h3>
                                            <div style={{display: "inline-block"}} className={"d-none"} id={"match-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>
                                                    {matchActive?.length ? matchActive.length : 0} Terms Defined
                                                </h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-minus as-btn collapse-toggle p-2"}
                                               id={"match-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("match-card-btn", "match-card");
                                                   document.getElementById("match-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content show"} id={"match-card"}>
                                        {virtualDeviceData.length > 0
                                            ?
                                                <>
                                                    <div className={"d-flex justify-content-between pb-3"}>
                                                        <div>
                                                            <Button text={`${matchTermTab === "terms" ? "Set Devices" : "Set Terms"}`}
                                                                    class={`btn btn-primary`}
                                                                    id={"set-virtual"}
                                                                    onClick={() => {
                                                                        if (matchTermTab === "terms"){
                                                                            setMatchTermTab("virtual");
                                                                        }else{
                                                                            setMatchTermTab("terms");
                                                                        }
                                                                    }}/>
                                                        </div>
                                                        <div className={matchTermTab === "terms" ? "" : "d-none"}>
                                                            {editRights
                                                                ?   <Button text={"Disable"} type={"button"}
                                                                           class={"btn btn-danger me-2 hide"}
                                                                           id={"deleteBtn"} icon={true}
                                                                           iconClass={"fe fe-trash-2 me-2"}
                                                                           onClick={() => bulkDeleteModal(ppRules2.start, ppRules2.end, matchActive,
                                                                               ["device_type", "area_name"], ["matchterm_id", ""], "", setDContent)}/>
                                                                :   <></>
                                                            }
                                                            {editRights
                                                                ?   <Button text={"New Term"} type={"button"}
                                                                           class={"btn btn-primary ms-2 mt-1"}
                                                                           icon={true} iconClass={"fe fe-plus me-2"}
                                                                           onClick={() => {
                                                                               setAddMatchTypeId(1);
                                                                               document.getElementById("addMatchForm").reset()
                                                                               showModal("addmatchmodal");
                                                                           }}/>
                                                                :   <></>
                                                            }
                                                        </div>
                                                        <div className={matchTermTab === "virtual" ? "" : "d-none"}>
                                                            {editRights
                                                                ?   <Button text={"Disable"} type={"button"}
                                                                           class={"btn btn-danger me-2 hide"}
                                                                           id={"deleteVirtualBtn"} icon={true}
                                                                           iconClass={"fe fe-trash-2 me-2"}
                                                                           onClick={() => bulkDeleteModal(0, virtualDeviceData.length, virtualDeviceData,
                                                                               ["device_name"], ["device_id", ""], "",
                                                                               setDContent, "Are you sure you want to delete the following devices? \n",
                                                                               "bulkdeletevirtualmodal", "deleteBulkVirtualModalContent", "uCheckVirtual")}/>
                                                                :   <></>
                                                            }
                                                            {editRights
                                                                ?   <Button text={"New Device"} type={"button"}
                                                                           class={"btn btn-primary ms-2 mt-1"}
                                                                           icon={true} iconClass={"fe fe-plus me-2"}
                                                                           onClick={() => {
                                                                               showModal("virtualdevicemodal");
                                                                           }}/>
                                                                :   <></>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{maxHeight: "600px", overflowY: "auto"}} className={matchTermTab === "terms" ? "" : "d-none"}>
                                                        <table className={"table table-sm table-responsive-sm table-hover"}>
                                                            <thead className={"sticky-table-head"} style={{top: 0}}>
                                                            {matchTermsHeaders}
                                                            </thead>
                                                            <tbody>
                                                            {matchTermsRows}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div style={{maxHeight: "600px", overflowY: "auto"}} className={matchTermTab === "virtual" ? "" : "d-none"}>
                                                        <table className={"table table-sm table-responsive-sm table-hover"}>
                                                            <thead className={"sticky-table-head"} style={{top: 0}}>
                                                            {virtualTableHeaders}
                                                            </thead>
                                                            <tbody>
                                                            {virtualDeviceRows}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>

                                            :
                                                <>
                                                    <div className={"d-flex justify-content-between pb-3"}>
                                                        <p>Must define device types</p>
                                                        <Button text={"New Device"} type={"button"}
                                                                class={"btn btn-primary ms-2 mt-1"}
                                                                icon={true} iconClass={"fe fe-plus me-2"}
                                                                onClick={() => {
                                                                   showModal("virtualdevicemodal");
                                                               }}/>
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                        : <></>
                    }
                </div>
            </div>
            <div className={"modal fade"} id={"addmatchmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={"-1"} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Match Term</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"addMatchForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-4 w-75 m-auto"}>
                                    <select className={"form-select"} value={addMatchTypeId}
                                            required={true} id={"add-match-type-id"}
                                            onChange={(e) => {
                                                setAddMatchTypeId(parseInt(e.target.value));
                                                formCheck("addMatchForm", "addMatchSubmit");
                                            }}>
                                        <option value={1}>Alarm Triggers</option>
                                        <option value={2}>Text Handling</option>
                                        <option value={3}>Area Handling</option>
                                        <option value={4}>Device Handling</option>
                                        <option value={5}>Ignore Cases</option>
                                    </select>
                                    <label htmlFor={"add-match-type-id"}>Match Term Configuration</label>
                                </div>
                                <div className={addMatchTypeId === 1 ? "d-block" : "d-none"}>
                                    <div className={"d-inline-block w-50 pe-2"}>
                                        <div className={"form-floating mb-3 d-block align-top pe-2"}>
                                            <input type={"text"} className={"form-control"} id={"create_pattern"}
                                                   onKeyUp={(e) => {
                                                       formCheck("addMatchForm", "addMatchSubmit");
                                                   }}/>
                                            <label htmlFor={"create_pattern"}>Create alarm on...</label>
                                            <div className={"invalid-feedback"}>
                                                Word to trigger alarm on.
                                            </div>
                                        </div>
                                        <div className={"form-floating mb-3 d-block align-top pe-2"}>
                                            <input type={"text"} className={"form-control"} id={"repeat_pattern"}
                                                   onKeyUp={(e) => {
                                                       formCheck("addMatchForm", "addMatchSubmit");
                                                   }}/>
                                            <label htmlFor={"repeat_pattern"}>Repeat alarm on...</label>
                                            <div className={"invalid-feedback"}>
                                                Word to repeat alarm on.
                                            </div>
                                        </div>
                                        <div className={"form-floating mb-3 d-block align-top pe-2"}>
                                            <input type={"text"} className={"form-control"} id={"clear_pattern"}
                                                   onKeyUp={(e) => {
                                                       formCheck("addMatchForm", "addMatchSubmit");
                                                   }}/>
                                            <label htmlFor={"clear_pattern"}>Clear alarm on...</label>
                                            <div className={"invalid-feedback"}>
                                                Word to clear alarm on.
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"d-inline-block w-50 ps-2 align-top"}>
                                        <div className={"form-floating mb-3 pe-2"}>
                                            <select className={"form-select"} value={eventCatId}
                                                    required={true} id={"add-event-cat-id"}
                                                    onChange={(e) => {
                                                        setEventCatId(e.target.value);
                                                        formCheck("addMatchForm", "addMatchSubmit");
                                                    }}>
                                                {eventCatOptions}
                                            </select>
                                            <label htmlFor={"add-event-cat-id"}>Alarm Category</label>
                                        </div>
                                        <div className={"form-floating mb-3 pe-2"}>
                                            <select className={"form-select"} value={eventTypeId}
                                                    required={true} id={"add-event-type-id"}
                                                    onChange={(e) => {
                                                        setEventTypeId(e.target.value);
                                                        formCheck("addMatchForm", "addMatchSubmit");
                                                    }}>
                                                {eventTypeOptions}
                                            </select>
                                            <label htmlFor={"add-event-type-id"}>Alarm Type</label>
                                        </div>
                                        <div className={"mt-4"}>
                                            <div className={"align-top ms-3 mt-2"}>
                                                <input className={"form-check-input mt-1"}
                                                       style={{width: "1.25rem", height: "1.25rem"}}
                                                       id={"add-iscase1"} type={"checkbox"}/>
                                                <label className={"form-check-label ms-2 fs-3"}
                                                       style={{color: "#1d1d1d"}}
                                                       htmlFor={"add-iscase1"}>Case Sensitive</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3 w-50 pe-3"}>
                                        <input type={"number"} className={"form-control"} id={"add-ttl"}
                                               min={0} max={60} step={1} required={true} defaultValue={0}
                                               title={"0 = Must clear via clear pattern, 1-60 = Time to live auto clear of alarm."}
                                               onKeyUp={() => formCheck("addMatchForm", "addMatchSubmit")}/>
                                        <label htmlFor={"add-ttl"}>Autoclear after x min...</label>
                                        <div className={"invalid-feedback"}>
                                            Number of minutes alarm should automatically clear. 0 = must clear via trigger word.
                                        </div>
                                    </div>
                                </div>
                                <div className={addMatchTypeId === 2 ? "d-block" : "d-none"}>
                                    <div className={"d-inline-block w-50 pe-2"}>
                                        <div className={"form-floating mb-3 d-block align-top"}>
                                            <input type={"text"} className={"form-control"} id={"add-pattern2"}
                                                   onKeyUp={(e) => {
                                                       formCheck("addMatchForm", "addMatchSubmit");
                                                   }}
                                                   required={false}/>
                                            <label htmlFor={"add-pattern2"}>When this is found...</label>
                                            <div className={"invalid-feedback"}>
                                                Found pattern
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"d-inline-block w-50 ps-2"}>
                                        <div className={"form-floating mb-3 d-block align-top"}>
                                            <input type={"text"} className={"form-control"} id={"add-replacement2"}
                                                   onKeyUp={(e) => {
                                                       formCheck("addMatchForm", "addMatchSubmit");
                                                   }}
                                                   required={false}/>
                                            <label htmlFor={"add-replacement2"}>Replace with...</label>
                                            <div className={"invalid-feedback"}>
                                                Replacement pattern
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"my-2"}>
                                        <div className={"align-top ms-3 mt-2"}>
                                            <input className={"form-check-input mt-1"}
                                                   style={{width: "1.25rem", height: "1.25rem"}}
                                                   id={"add-iscase2"} type={"checkbox"}/>
                                            <label className={"form-check-label ms-2 fs-3"}
                                                   style={{color: "#1d1d1d"}}
                                                   htmlFor={"add-iscase2"}>Case Sensitive</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={addMatchTypeId === 3 ? "d-block" : "d-none"}>
                                    <div className={"d-flex justify-content-around"}>
                                        <div className={"d-inline-block"} style={{width: "150px"}}>
                                            {editRights
                                                ?   <Button text={"Map Areas"} class={"btn btn-primary w-100"}
                                                        onClick={() => {
                                                            swapModal("cancelAddMatchBtn", "areamapmodal");
                                                        }}/>
                                                :   <></>
                                            }
                                            <h5 className={"text-center mt-1"}>{matchAreaMap.length} Mapped</h5>
                                        </div>
                                        <div className={"d-inline-block align-top ms-3 mt-2"}>
                                            <input className={"form-check-input mt-1"}
                                                   style={{width: "1.25rem", height: "1.25rem"}}
                                                   id={"add-iscase3"} type={"checkbox"}/>
                                            <label className={"form-check-label ms-2 fs-3"} style={{color: "#1d1d1d"}}
                                                   htmlFor={"add-iscase3"}>Case Sensitive</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={addMatchTypeId === 4 ? "d-block" : "d-none"}>
                                    <div className={"d-flex justify-content-around"}>
                                        <div className={"d-inline-block me-3"} style={{width: "150px"}}>
                                            {editRights
                                                ? <Button text={"Map Devices"} class={"btn btn-primary w-100"}
                                                        onClick={() => {
                                                            swapModal("cancelAddMatchBtn", "devicemapmodal");
                                                        }}/>
                                                :   <></>
                                            }
                                            <h5 className={"text-center mt-1"}>{matchDeviceMap.length} Mapped</h5>
                                        </div>
                                        <div className={"d-inline-block align-top ms-3 mt-2"}>
                                            <input className={"form-check-input mt-1"}
                                                   style={{width: "1.25rem", height: "1.25rem"}}
                                                   id={"add-iscase4"} type={"checkbox"}/>
                                            <label className={"form-check-label ms-2 fs-3"} style={{color: "#1d1d1d"}}
                                                   htmlFor={"add-iscase4"}>Case Sensitive</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={addMatchTypeId === 5 ? "d-block" : "d-none"}>
                                    <div className={"form-floating mb-3 d-inline-block w-50 align-top pe-2"}>
                                        <input type={"text"} className={"form-control"} id={"add-pattern5"}
                                               onKeyUp={(e) => {
                                                   formCheck("addMatchForm", "addMatchSubmit");
                                               }}/>
                                        <label htmlFor={"add-pattern5"}>Ignore all actions on...</label>
                                        <div className={"invalid-feedback"}>
                                            Word or pattern when found will ignore all alarm triggers.
                                        </div>
                                    </div>
                                    <div className={"d-inline-block align-top ms-3 mt-2"}>
                                        <input className={"form-check-input mt-1"}
                                               style={{width: "1.25rem", height: "1.25rem"}}
                                               id={"add-iscase5"} type={"checkbox"}/>
                                        <label className={"form-check-label ms-2 fs-3"} style={{color: "#1d1d1d"}}
                                               htmlFor={"add-iscase5"}>Case Sensitive</label>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddMatchBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadAddMatchSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"}
                                        onClick={() => formAddMatchSubmit()} id={"addMatchSubmit"}>Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"devicemapmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title text-capitalize"} id={"staticBackdropLabel"}>Map Device Patterns
                                Matching</h2>
                            <button type={"button"} className={"btn-close"} id={"deviceMapClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"deviceMapForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"list-group-item"}>
                                    {editRights
                                        ?   <Button type={"button"} class={"btn btn-primary mb-3"} text={"New Device Match"}
                                                onClick={() => {
                                                    setTmpDeviceMap((prevState) => {
                                                        return [...prevState, {id: uuidv4(), device_id: 0, pattern: "", replacement: "", type: 2}]
                                                    });
                                            }}/>
                                        :   <></>
                                    }
                                    {tmpDeviceMap.map((item) => {
                                        return (
                                            <div key={`new-device-item${item.id}`}
                                                 className={"d-flex justify-content-start"}>
                                                <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                   onClick={() => {
                                                       setTmpDeviceMap((prevState) => {
                                                           return prevState.filter(i => i.id !== item.id);
                                                       });
                                                   }}></i>
                                                <div className={"form-floating d-inline-block w-50 mb-3 mx-3"}>
                                                    <input type={"text"} name={"device-pattern-input"}
                                                           className={"form-control"}
                                                           id={`tmp-device-pattern${item.id}`}
                                                           onKeyUp={(e) => {
                                                               setTmpDeviceMap((prevState) => {
                                                                   return prevState.map((i) => {
                                                                       if (i.id === item.id) {
                                                                           return {
                                                                               id: i.id,
                                                                               pattern: e.target.value,
                                                                               replacement: i.replacement,
                                                                               type: i.type,
                                                                               device_id: i.device_id
                                                                           };
                                                                       }
                                                                       return i;
                                                                   });
                                                               })
                                                               formCheck("deviceMapForm", "deviceMapSubmit");
                                                           }} required={false}
                                                           defaultValue={item.pattern}/>
                                                    <label htmlFor={`tmp-device-pattern${item.id}`}>Match Pattern</label>
                                                </div>
                                                <div className={"form-floating mb-3 w-50 pe-2"}>
                                                    <select className={"form-select"} defaultValue={item.device_id}
                                                            required={false} id={`tmp-device-replacement${item.id}`}
                                                            onChange={(e) => {
                                                                setTmpDeviceMap((prevState) => {
                                                                    return prevState.map((i) => {
                                                                        if (i.id === item.id) {
                                                                            return {
                                                                                id: i.id,
                                                                                pattern: i.pattern,
                                                                                replacement: e.target.options[e.target.selectedIndex].innerText,
                                                                                type: i.type,
                                                                                device_id: parseInt(e.target.value)
                                                                            };
                                                                        }
                                                                        return i;
                                                                    });
                                                                })
                                                                formCheck("deviceMapForm", "deviceMapSubmit");
                                                            }}>
                                                        <option value={0}></option>
                                                        {virtualDeviceData.map((item) => {
                                                            return <option value={item.device_id}>{item.device_name}</option>
                                                        })}
                                                    </select>
                                                    <label htmlFor={`tmp-device-replacement${item.id}`}>Device Type</label>
                                                </div>
                                            </div>);
                                    })}
                                </div>
                                <hr/>
                                <div className={"list-group-item"}>
                                    <h4>Current Mapped Patterns</h4>
                                    <h5 className={"mb-4"}>
                                        * Removing the below patterns will remove them without submit action.
                                    </h5>
                                    {matchDeviceMap.map((item) => {
                                        return (
                                            <div key={`stored-deviceMap-${item.id}`}
                                                 className={"d-flex justify-content-start"}>
                                                <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                   onClick={() => {
                                                       setMatchDeviceMap((prevState) => {
                                                           return prevState.filter(i => i?.id !== item.id);
                                                       });
                                                   }}></i>
                                                <div className={"form-floating d-inline-block w-50 mb-3 mx-3"}>
                                                    <input type={"text"} name={"device-pattern-input"}
                                                           className={"form-control"}
                                                           id={`tmp-device-pattern-${item.id}`}
                                                           value={item.pattern} readOnly={true}/>
                                                    <label htmlFor={`tmp-device-pattern-${item.id}`}>Match
                                                        Pattern</label>
                                                </div>
                                                <div className={"form-floating d-inline-block w-50 mb-3 mx-3"}>
                                                    <input type={"text"} name={"device-replacement-input"}
                                                           className={"form-control"}
                                                           id={`tmp-device-replacement${item.id}`}
                                                           value={item.replacement} readOnly={true}/>
                                                    <label htmlFor={`tmp-device-replacement${item.id}`}>Device Type</label>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelDeviceMapBtn"}
                                            data-bs-dismiss={"modal"} onClick={() => {
                                        setTmpDeviceMap([]);
                                        swapModal("devicemapmodal", "addmatchmodal");
                                    }}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadDeviceMapSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} id={"deviceMapSubmit"}
                                            onClick={() => deviceMapUpdater()}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"virtualdevicemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={"-1"} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Virtual Devices</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"addVirtualForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                {
                                    virtualDeviceTypeData.map((item) => {
                                        if (!virtualDeviceData.some((vItem) => vItem?.device_type_id === item.device_type_id)){
                                            return (<div className={"d-flex justify-content-start"}>
                                                        <div key={`v-device-${item.device_type_id}`} className={"mt-2 mb-4 d-block w-50"}>
                                                            <div className={"align-top ms-3"} id={`v-device-${item.device_type_id}-div`}>
                                                                <input className={"form-check-input mt-1"} name={"virtualdeviceadd"}
                                                                       value={item.device_type_id}
                                                                       style={{width: "1.25rem", height: "1.25rem"}}
                                                                       id={`v-device-${item.device_type_id}`} type={"checkbox"}/>
                                                                <label className={"form-check-label ms-2 fs-3"}
                                                                       style={{color: "#1d1d1d"}}
                                                                       htmlFor={`v-device-${item.device_type_id}`}>{item.device_type_name}</label>
                                                            </div>
                                                        </div>
                                                        <div className={"form-floating mb-3 d-block align-top pe-2 w-50"}>
                                                            <input type={"text"} className={"form-control"} id={`v-device-name-${item.device_type_id}`}
                                                                   pattern={"^[A-Za-z ]+"} />
                                                            <label htmlFor={`v-device-name-${item.device_type_id}`}>Custom Name</label>
                                                        </div>
                                                    </div>);
                                        }
                                        return null;
                                    })
                                }
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddVirtualBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                {editRights
                                    ?   <>
                                            <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                                    spinner={true}
                                                    text={"Loading"} id={"loadAddVirtualSubmit"}/>
                                            <button type={"button"} className={"btn btn-primary"}
                                                    onClick={() => formAddVirtualDeviceSubmit()} id={"addVirtualSubmit"}>Submit
                                            </button>
                                        </>
                                    :   <></>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"areamapmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title text-capitalize"} id={"staticBackdropLabel"}>Map Area Patterns
                                Matching</h2>
                            <button type={"button"} className={"btn-close"} id={"deviceMapClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"areaMapForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"list-group-item"}>
                                    {editRights
                                        ?   <Button type={"button"} class={"btn btn-primary mb-3"} text={"New Area Match"}
                                                onClick={() => {
                                                    setTmpAreaMap((prevState) => {
                                                        return [...prevState, {id: uuidv4(), pattern: "", replacement: "",
                                                                               display: "", type: 1}]
                                                    });
                                            }}/>
                                        :   <></>
                                    }
                                    {tmpAreaMap.map((item) => {
                                        return (
                                            <div key={`new-area-item${item.id}`}
                                                 className={"d-flex justify-content-start"}>
                                                <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                   onClick={() => {
                                                       setTmpAreaMap((prevState) => {
                                                           return prevState.filter(i => i.id !== item.id);
                                                       });
                                                   }}></i>
                                                <div className={"form-floating d-inline-block w-50 mb-3 mx-3"}>
                                                    <input type={"text"} name={"area-pattern-input"}
                                                           className={"form-control"}
                                                           id={`tmp-area-pattern${item.id}`}
                                                           onKeyUp={(e) => {
                                                               setTmpAreaMap((prevState) => {
                                                                   return prevState.map((i) => {
                                                                       if (i.id === item.id) {
                                                                           return {
                                                                               id: i.id,
                                                                               pattern: e.target.value,
                                                                               replacement: i.replacement,
                                                                               display: i.display,
                                                                               type: i.type
                                                                           };
                                                                       }
                                                                       return i;
                                                                   });
                                                               })
                                                               formCheck("areaMapForm", "areaMapSubmit");
                                                           }} required={false}
                                                           defaultValue={item.pattern}/>
                                                    <label htmlFor={`tmp-area-pattern${item.id}`}>Match Pattern</label>
                                                </div>
                                                <div className={"form-floating mb-3 w-50 pe-2"}>
                                                    <select className={"form-select"} defaultValue={item.replacement}
                                                            required={false} id={`tmp-device-replacement${item.id}`}
                                                            onChange={(e) => {
                                                                setTmpAreaMap((prevState) => {
                                                                    return prevState.map((i) => {
                                                                        if (i.id === item.id) {
                                                                            return {
                                                                                id: i.id,
                                                                                pattern: i.pattern,
                                                                                replacement: e.target.value,
                                                                                display: e.target[e.target.selectedIndex].innerText,
                                                                                type: i.type
                                                                            };
                                                                        }
                                                                        return i;
                                                                    });
                                                                })
                                                                formCheck("areaMapForm", "areaMapSubmit")
                                                            }}>
                                                        <option value={""}></option>
                                                        {locationOptions}
                                                    </select>
                                                    <label htmlFor={`tmp-area-replacement${item.id}`}>Area</label>
                                                </div>
                                            </div>);
                                    })}
                                </div>
                                <hr/>
                                <div className={"list-group-item"}>
                                    <h4>Current Mapped Patterns</h4>
                                    <h5 className={"mb-4"}>* Removing the below patterns will remove them without submit
                                        action.</h5>
                                    {matchAreaMap.map((item) => {
                                        return (
                                            <div key={`stored-areaMap-${item.id}`}
                                                 className={"d-flex justify-content-start"}>
                                                <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                   onClick={() => {
                                                       setMatchAreaMap((prevState) => {
                                                           return prevState.filter(i => i?.id !== item.id);
                                                       })
                                                   }}></i>
                                                <div className={"form-floating d-inline-block w-50 mb-3 mx-3"}>
                                                    <input type={"text"} name={"area-pattern-input"}
                                                           className={"form-control"}
                                                           id={`tmp-area-pattern-${item.id}`}
                                                           value={item.pattern} readOnly={true}/>
                                                    <label htmlFor={`tmp-area-pattern-${item.id}`}>Match
                                                        Pattern</label>
                                                </div>
                                                <div className={"form-floating d-inline-block w-50 mb-3 mx-3"}>
                                                    <input type={"text"} name={"area-replacement-input"}
                                                           className={"form-control"}
                                                           id={`tmp-area-replacement${item.id}`}
                                                           value={item.display} readOnly={true}/>
                                                    <label htmlFor={`tmp-area-replacement${item.id}`}>Area</label>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelAreaMapBtn"}
                                            data-bs-dismiss={"modal"} onClick={() => {
                                        setTmpAreaMap([]);
                                        swapModal("areamapmodal", "addmatchmodal")
                                    }}>Cancel</button>
                                    {editRights
                                        ?   <>
                                                <Button type={"button"} class={"btn btn-primary d-none ms-3"}
                                                        disabled={true}
                                                        spinner={true} text={"Loading"} id={"loadAreaMapSubmit"}/>
                                                <button type={"button"} className={"btn btn-primary ms-3"}
                                                        id={"areaMapSubmit"}
                                                        onClick={() => areaMapUpdater()}>Submit
                                                </button>
                                            </>
                                        :   <></>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editmatchmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={"-1"} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Edit Match Term</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"editMatchForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <input id={"matchterm_idE"} type={"hidden"} className={"d-none"}/>
                                <div className={"d-inline-block w-50 pe-2"}>
                                    <div className={"d-block"}>
                                        <div className={"form-floating mb-3 d-block align-top"} id={"c-patternE"}>
                                            <input type={"text"} className={"form-control"} id={"patternE"}
                                                   onKeyUp={(e) => {
                                                       formCheck("editMatchForm", "editMatchSubmit");
                                                   }}
                                                   required={false}/>
                                            <label htmlFor={"patternE"}>Pattern</label>
                                            <div className={"invalid-feedback"}>
                                                Pattern required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"d-inline-block w-50 ps-2"}>
                                    <div className={"form-floating mb-3 d-block align-top"} id={"c-replacementE"}>
                                        <input type={"text"} className={"form-control"} id={"replacementE"}
                                               onKeyUp={(e) => {
                                                   formCheck("editMatchForm", "editMatchSubmit");
                                               }}
                                               required={false}/>
                                        <label htmlFor={"replacementE"}>Replacement</label>
                                        <div className={"invalid-feedback"}>
                                            Replacement pattern
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3 d-block align-top"} id={"c-device_idE"}>
                                        <select className={"form-select"} id={"device_idE"}
                                                onChange={(e) => {
                                                    formCheck("editMatchForm", "editMatchSubmit")
                                                }}>
                                            <option value={0}>None</option>
                                            {virtualDeviceData.map((item) => {
                                                return <option value={item.device_id}>{item.device_name}</option>
                                            })}
                                        </select>
                                        <label htmlFor={"device_idE"}>Device Type</label>
                                    </div>
                                    <div className={"form-floating mb-3 d-block align-top"} id={"c-area_idE"}>
                                        <select className={"form-select"} id={"area_idE"}
                                                onChange={(e) => {
                                                    formCheck("editMatchForm", "editMatchSubmit")
                                                }}>
                                            <option value={0}>None</option>
                                            {locationOptions}
                                        </select>
                                        <label htmlFor={"area_idE"}>Replacement</label>
                                    </div>
                                    <div className={"form-floating mb-3 d-block align-top"} id={"c-ttlE"}>
                                        <input type={"text"} className={"form-control"} id={"ttlE"}
                                               onKeyUp={(e) => {
                                                   formCheck("editMatchForm", "editMatchSubmit");
                                               }}
                                               required={false}/>
                                        <label htmlFor={"ttlE"}>TTL (Min)</label>
                                        <div className={"invalid-feedback"}>
                                            Length alarm will live in minutes.
                                        </div>
                                    </div>
                                </div>
                                <div className={"mt-2 mb-4 d-block"}>
                                    <div className={"align-top ms-3"} id={"c-iscaseE"}>
                                        <input className={"form-check-input mt-1"}
                                               style={{width: "1.25rem", height: "1.25rem"}}
                                               id={"iscaseE"} type={"checkbox"}/>
                                        <label className={"form-check-label ms-2 fs-3"}
                                               style={{color: "#1d1d1d"}}
                                               htmlFor={"iscaseE"}>Case Sensitive</label>
                                    </div>
                                </div>
                                <div className={"d-inline-block w-50 pe-2"}>
                                    <div className={"form-floating mb-3 pe-2"} id={"c-event_cat_idE"}>
                                        <select className={"form-select"} value={eventCatId}
                                                required={true} id={"event_cat_idE"}
                                                onChange={(e) => {
                                                    setEventCatId(e.target.value);
                                                    formCheck("addMatchForm", "addMatchSubmit");
                                                }}>
                                            {eventCatOptions}
                                        </select>
                                        <label htmlFor={"event_cat_idE"}>Alarm Category</label>
                                    </div>
                                </div>
                                <div className={"d-inline-block w-50 ps-2"}>
                                    <div className={"form-floating mb-3"} id={"c-event_type_idE"}>
                                        <select className={"form-select"} value={eventTypeId}
                                                required={true} id={"event_type_idE"}
                                                onChange={(e) => {
                                                    setEventTypeId(e.target.value);
                                                    formCheck("addMatchForm", "addMatchSubmit");
                                                }}>
                                            {eventTypeOptions}
                                        </select>
                                        <label htmlFor={"event_type_idE"}>Alarm Type</label>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelMatchEditBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                {editRights
                                    ?   <>
                                            <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                                    spinner={true}
                                                    text={"Loading"} id={"loadEditMatchSubmit"}/>
                                            <button type={"button"} className={"btn btn-primary"}
                                                    onClick={() => formEditMatchSubmit()} id={"editMatchSubmit"}>Submit
                                            </button>
                                        </>
                                    :   <></>
                                }
                            </div>
                        </form>
                    </div>
            </div>
            </div>
            <div className={"modal fade"} id={"dbeditmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={"-1"} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Edit Server Database</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"editDBForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <h3 className={"ms-1 mb-2"}>Serial In</h3>
                                <div className={"d-inline-block form-floating mb-3 w-50 pe-2 align-top"}>
                                    <input type={"text"} className={"form-control"} id={"serialIn"}
                                           onKeyUp={() => formCheck("editDBForm", "editDBSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <input type={"hidden"} id={"serialInId"}/>
                                    <label htmlFor={"serialIn"}>Port Address</label>
                                    <div className={"invalid-feedback"}>
                                        Enter a valid port!
                                    </div>
                                </div>
                                <div className={"d-inline-block form-floating mb-3 w-50 ps-2 align-top"}>
                                    <input type={"text"} className={"form-control"} id={"in_serial_delimiter"}
                                           onKeyUp={() => formCheck("editDBForm", "editDBSubmit")}
                                           pattern={"(<CR>|<LF>|<HT>|<NULL>|<BS>|<FF>|<VT>)*"}/>
                                    <input type={"hidden"} id={"in_serial_delimiter_id"}/>
                                    <label htmlFor={"in_serial_delimiter"}>Message Delimiters</label>
                                    <div className={"invalid-feedback"}>
                                        Enter valid delimiters
                                        <br/>
                                        Examples {'<CR>|<LF>|<HT>|<NULL>|<BS>|<FF>|<VT> no spaces or punctuation'}!
                                    </div>
                                </div>
                                <div className={"form-floating mb-5"}>
                                    <select className={"form-select"}
                                            onChange={() => formCheck("editDBForm", "editDBSubmit")}
                                            id={"in_serial_baud"} defaultValue={"600"}>
                                        <option value="110">110</option>
                                        <option value="300">300</option>
                                        <option value="600">600</option>
                                        <option value="1200">1200</option>
                                        <option value="2400">2400</option>
                                        <option value="4800">4800</option>
                                        <option value="9600">9600</option>
                                        <option value="14400">14400</option>
                                        <option value="19200">19200</option>
                                        <option value="38400">38400</option>
                                        <option value="57600">57600</option>
                                        <option value="115200">115200</option>
                                        <option value="128000">128000</option>
                                    </select>
                                    <input type={"hidden"} id={"in_serial_baud_id"}/>
                                    <label htmlFor={"in_serial_baud"}>Baud Rate</label>
                                </div>
                                <h3 className={"ms-1 mb-2"}>Serial Out</h3>
                                <div className={"d-inline-block form-floating mb-3 w-50 pe-2 align-top"}>
                                    <input type={"text"} className={"form-control"} id={"serialOut"}
                                           onKeyUp={() => formCheck("editDBForm", "editDBSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <input type={"hidden"} id={"serialOutId"}/>
                                    <label htmlFor={"serialOut"}>Port Address</label>
                                    <div className={"invalid-feedback"}>
                                        Enter a valid port!
                                    </div>
                                </div>
                                <div className={"d-inline-block form-floating mb-3 w-50 ps-2 align-top"}>
                                    <input type={"text"} className={"form-control"} id={"out_serial_delimiter"}
                                           onKeyUp={() => formCheck("editDBForm", "editDBSubmit")}
                                           pattern={"(<CR>|<LF>|<HT>|<NULL>|<BS>|<FF>|<VT>)*"}/>
                                    <input type={"hidden"} id={"out_serial_delimiter_id"}/>
                                    <label htmlFor={"out_serial_delimiter"}>Message Delimiters</label>
                                    <div className={"invalid-feedback"}>
                                        Enter valid delimiters
                                        <br/>
                                        Examples {'<CR>|<LF>|<HT>|<NULL>|<BS>|<FF>|<VT> no spaces or punctuation'}!
                                    </div>
                                </div>
                                <div className={"form-floating mb-5"}>
                                    <select className={"form-select"}
                                            onChange={() => formCheck("editDBForm", "editDBSubmit")}
                                            id={"out_serial_baud"} defaultValue={"600"}>
                                        <option value="110">110</option>
                                        <option value="300">300</option>
                                        <option value="600">600</option>
                                        <option value="1200">1200</option>
                                        <option value="2400">2400</option>
                                        <option value="4800">4800</option>
                                        <option value="9600">9600</option>
                                        <option value="14400">14400</option>
                                        <option value="19200">19200</option>
                                        <option value="38400">38400</option>
                                        <option value="57600">57600</option>
                                        <option value="115200">115200</option>
                                        <option value="128000">128000</option>
                                    </select>
                                    <input type={"hidden"} id={"out_serial_baud_id"}/>
                                    <label htmlFor={"out_serial_baud"}>Baud Rate</label>
                                </div>
                                <h3 className={"ms-1 mb-2"}>Event Config</h3>
                                <div className={"form-floating mb-5"}>
                                    <input type={"text"} className={"form-control"} id={"config_ttl"}
                                           onKeyUp={() => formCheck("editDBForm", "editDBSubmit")}
                                           pattern={"[0-9]+"}/>
                                    <input type={"hidden"} id={"config_ttl_id"}/>
                                    <label htmlFor={"config_ttl"}>Global Auto-Clear Time to Live</label>
                                    <div className={"invalid-feedback"}>
                                        Enter a ttl, numbers only!
                                    </div>
                                </div>
                                <h3 className={"ms-1 mb-2"}>Local Environment Config</h3>
                                <div className={"d-flex justify-content-between mb-3"}>
                                    <div className={`p-2 border ${evActive ? "border-success" : ""} rounded`}>
                                        <h4 className={"mb-2 me-1"}>Environment Processing</h4>
                                        <div className={"form-check form-switch"}>
                                            <input type={"checkbox"} className={"form-check-input"}
                                                   id={"config_env_processing"}
                                                   onChange={(e) => {
                                                       setEvActive(e.target.checked);
                                                       formCheck("editDBForm", "editDBSubmit");
                                                   }}/>
                                            <input type={"hidden"} id={"config_env_processing_id"}/>
                                            <label htmlFor={"config_env_processing"}>
                                                <span id={"in-label-off"}
                                                      className={!evActive ? "text-danger fw-bold" : ""}>
                                                    Off
                                                </span>/
                                                <span id={"in-label-on"}
                                                      className={evActive ? "text-success-bright fw-bold" : ""}>
                                                    On
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className={"form-floating ps-2"} style={{width: "33.33%"}}>
                                        <input type={"number"} className={"form-control"} id={"config_env_sample_rate"}
                                               onChange={() => {
                                                   formCheck("editDBForm", "editDBSubmit");
                                               }}
                                               min={30} max={1800} step={1}/>
                                        <input type={"hidden"} id={"config_env_sample_rate_id"}/>
                                        <label htmlFor={"config_env_sample_rate"}>Sample Rate</label>
                                        <div className={"invalid-feedback"}>
                                            Enter how often in minutes to collect environment data from devices.
                                            30 minute minimum.
                                        </div>
                                    </div>
                                </div>
                                <div className={"d-flex justify-content-between mb-5"}>
                                    <div className={"form-floating pe-2"} style={{width: "33.33%"}}>
                                        <input type={"number"} className={"form-control"} id={"config_low_temp"}
                                               onChange={(e) => {
                                                   document.getElementById("config_high_temp").min = parseInt(e.target.value) + 1;
                                                   formCheck("editDBForm", "editDBSubmit");
                                               }}
                                               min={0} max={120} step={1}/>
                                        <input type={"hidden"} id={"config_low_temp_id"}/>
                                        <label htmlFor={"config_low_temp"}>Low Temperature</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid temperature below high temp
                                        </div>
                                    </div>
                                    <div className={"form-floating px-1"} style={{width: "33.33%"}}>
                                        <input type={"number"} className={"form-control"} id={"config_high_temp"}
                                               onChange={(e) => {
                                                   document.getElementById("config_low_temp").max = parseInt(e.target.value) - 1;
                                                   formCheck("editDBForm", "editDBSubmit");
                                               }} min={0} max={120} step={1}/>
                                        <input type={"hidden"} id={"config_high_temp_id"}/>
                                        <label htmlFor={"config_high_temp"}>High Temperature</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid temperature above low temp
                                        </div>
                                    </div>
                                    <div className={"form-floating ps-2"} style={{width: "33.33%"}}>
                                        <input type={"number"} className={"form-control"} id={"config_low_bat"}
                                               onChange={() => formCheck("editDBForm", "editDBSubmit")}
                                               min={1} max={6} step={.1}/>
                                        <input type={"hidden"} id={"config_low_bat_id"}/>
                                        <label htmlFor={"config_low_bat"}>Low Battery</label>
                                        <div className={"invalid-feedback"}>
                                            Enter valid battery voltage level
                                        </div>
                                    </div>
                                </div>
                                <h3 className={"ms-1 mb-2"}>Communication Lost Settings</h3>
                                <div className={"d-inline-block form-floating mb-3 w-50 pe-2 align-top"}>
                                    <input type={"number"} className={"form-control"} id={"in_CheckinTime"}
                                           required={true} min={120} max={3600}
                                           onKeyUp={() => formCheck("editDBForm", "editDBSubmit")} />
                                    <input type={"hidden"} id={"in_CheckinTime_id"}/>
                                    <label htmlFor={"in_CheckinTime"}>Resident Devices (min)</label>
                                    <div className={"invalid-feedback"}>

                                    </div>
                                </div>
                                <div className={"d-inline-block form-floating mb-3 w-50 ps-2 align-top"}>
                                    <input type={"number"} className={"form-control"} id={"config_inoLocCheckinTime"}
                                           required={true} min={120} max={3600}
                                           onKeyUp={() => formCheck("editDBForm", "editDBSubmit")} />
                                    <input type={"hidden"} id={"config_inoLocCheckinTime_id"}/>
                                    <label htmlFor={"config_inoLocCheckinTime"}>Area Devices (min)</label>
                                    <div className={"invalid-feedback"}>

                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditDBBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    {editRights
                                        ?   <>
                                                <Button type={"button"} class={"btn btn-primary d-none ms-3"}
                                                        disabled={true}
                                                        spinner={true} text={"Loading"} id={"loadEditDBSubmit"}/>
                                                <button type={"button"} className={"btn btn-primary ms-3"}
                                                        id={"editDBSubmit"}
                                                        onClick={() => basicDBSubmit()}>Submit
                                                </button>
                                            </>
                                        :   <></>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <BulkDeleteModal
                deletePerform={() => deleteMatchPerform("bulkDeleteSubmit", "loadBulkDeleteSubmit",
                    "bulkConfirmClose", ppRules2.start, ppRules2.end)}
                start={ppRules.start} end={ppRules.end} header={"Delete Match Term"}/>
            <BulkDeleteModal closeBtn={"bulkConfirmVirtualClose"} cancelBtn={"bulkCancelDeleteVirtualBtn"} loadBtn={"loadBulkDeleteVirtualSubmit"}
                             submitBtn={"bulkDeleteVirtualSubmit"} modalContent={"deleteBulkVirtualModalContent"} modalName={"bulkdeletevirtualmodal"}
                deletePerform={() => deleteVirtualPerform("bulkDeleteVirtualSubmit", "loadBulkDeleteVirtualSubmit", "bulkConfirmVirtualClose", 0, virtualDeviceData.length)}
                start={0} end={virtualDeviceData.length} header={"Delete Virtual Devices"}/>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                                              setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                                              setPage={(sudocode) => setLogPage(sudocode)}/>
            <button
                type={"button"}
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Server Profile Page Help</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    This page provides a comprehensive overview and management interface for a specific server device in your system. You can view and edit basic information, configure database settings, manage match terms, review server logs, and troubleshoot server issues.
                                </p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-layers me-2 text-primary"}></i>Page Tabs
                                </h5>
                                <p className={"mb-2"}>The page is organized into several tabs:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Basic Info</strong>: View and edit fundamental server details like description, MAC address, product interface, hardware, OS, IP address, area, and implementation status.</li>
                                    <li className={"mb-2"}><strong>Database</strong>: View and edit server database configuration settings, validate database integrity, and fix configuration issues.</li>
                                    {[1, 2].includes(interfaceId)
                                        ? <li className={"mb-2"}><strong>Match Terms</strong>: Configure match terms for pattern matching and alarm processing (available for Hard-Wired and Firepanel interfaces).</li>
                                        : <></>
                                    }
                                    {dData?.campusData[dData?.acnt.toString()]?.is_cloud
                                        ? <li className={"mb-2"}><strong>Server Logs</strong>: View server activity logs (available for cloud installations).</li>
                                        : <></>
                                    }
                                    <li className={"mb-2"}><strong>Troubleshooting</strong>: View server status information, queue counts, and local alerts for debugging purposes.</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-info me-2 text-primary"}></i>Basic Info Tab
                                </h5>
                                <p className={"mb-2"}>This tab displays the server's basic information:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Description</strong>: The server description (editable with proper permissions).</li>
                                    <li className={"mb-2"}><strong>MAC Address</strong>: The server's MAC address (read-only).</li>
                                    <li className={"mb-2"}><strong>Product Interface</strong>: The interface type - Inovonics, Hard-Wired, or Firepanel (editable).</li>
                                    <li className={"mb-2"}><strong>Hardware</strong>: Server hardware information (read-only).</li>
                                    <li className={"mb-2"}><strong>System OS</strong>: Operating system information (read-only).</li>
                                    <li className={"mb-2"}><strong>Local IP</strong>: The server's IP address (read-only).</li>
                                    <li className={"mb-2"}><strong>Implementation</strong>: Whether the server is Main (active) or Backup (editable).</li>
                                    <li className={"mb-2"}><strong>Area</strong>: The area where the server is located (editable, clickable link to area profile).</li>
                                    {dData?.campusData[dData?.acnt.toString()]?.is_cloud
                                        ? <>
                                            <li className={"mb-2"}><strong>Last Heartbeat</strong>: When the server last communicated with the system.</li>
                                            <li className={"mb-2"}><strong>Online Status</strong>: Visual indicator showing if the server is online (green), offline (red), or unknown (gray).</li>
                                        </>
                                        : <></>
                                    }
                                    <li className={"mb-2"}><strong>Last Alarm</strong>: Timestamp of the most recent alarm processed.</li>
                                    <li className={"mb-2"}><strong>Active Alarms</strong>: Current count of active alarms.</li>
                                    <li className={"mb-2"}><strong>Last Rebooted</strong>: When the server was last rebooted.</li>
                                    <li className={"mb-2"}><strong>Uptime (Hrs)</strong>: How long the server has been running.</li>
                                </ul>
                                <p className={"mb-2"}>Click the "Edit" button to modify server information. Changes require appropriate permissions.</p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-database me-2 text-primary"}></i>Database Tab
                                </h5>
                                <p className={"mb-2"}>This tab allows you to manage server database configuration:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Database Validation</strong>: Check if the server database exists and validate its configuration.</li>
                                    <li className={"mb-2"}><strong>Fix Database</strong>: Automatically fix missing or extra configuration items (requires appropriate permissions).</li>
                                    <li className={"mb-2"}><strong>Edit Database</strong>: Manually edit database configuration settings including:
                                        <ul className={"list-unstyled ms-4"}>
                                            <li className={"mb-2"}>Serial port configurations (in/out ports, baud rates, message delimiters)</li>
                                            <li className={"mb-2"}>Event configuration (global auto-clear TTL)</li>
                                            <li className={"mb-2"}>Environmental processing settings (sample rates, temperature thresholds, battery levels)</li>
                                            <li className={"mb-2"}>Communication lost settings (check-in times for resident and area devices)</li>
                                        </ul>
                                    </li>
                                    <li className={"mb-2"}>Search through configuration items using the search bar.</li>
                                    <li className={"mb-2"}>View configuration details including config name, value, data type, and description.</li>
                                </ul>
                                <p className={"mb-2"}>Database configuration changes affect how the server processes events and communicates with devices.</p>
                            </div>

                            {[1, 2].includes(interfaceId)
                                ? <div className={"mb-4"}>
                                    <h5 className={"fw-bold mb-2"}>
                                        <i className={"fe fe-code me-2 text-primary"}></i>Match Terms Tab
                                    </h5>
                                    <p className={"mb-2"}>This tab (available for Hard-Wired and Firepanel interfaces) allows you to configure pattern matching:</p>
                                    <ul className={"list-unstyled ms-4"}>
                                        <li className={"mb-2"}><strong>Alarm Triggers</strong>: Define patterns that create, repeat, or clear alarms with associated alarm categories and types.</li>
                                        <li className={"mb-2"}><strong>Text Handling</strong>: Replace text patterns with different values.</li>
                                        <li className={"mb-2"}><strong>Area Handling</strong>: Map text patterns to specific areas.</li>
                                        <li className={"mb-2"}><strong>Device Handling</strong>: Map text patterns to specific device types.</li>
                                        <li className={"mb-2"}><strong>Ignore Cases</strong>: Define patterns that should be ignored completely.</li>
                                        <li className={"mb-2"}><strong>Virtual Devices</strong>: Manage virtual device types that can be used in match terms.</li>
                                        <li className={"mb-2"}>Edit existing match terms by clicking the edit icon in the table.</li>
                                        <li className={"mb-2"}>Delete match terms using the checkboxes and delete button (requires appropriate permissions).</li>
                                    </ul>
                                    <p className={"mb-2"}>Match terms are processed in order and help translate incoming messages into system events.</p>
                                </div>
                                : <></>
                            }

                            {dData?.campusData[dData?.acnt.toString()]?.is_cloud
                                ? <div className={"mb-4"}>
                                    <h5 className={"fw-bold mb-2"}>
                                        <i className={"fe fe-file-text me-2 text-primary"}></i>Server Logs Tab
                                    </h5>
                                    <p className={"mb-2"}>This tab (available for cloud installations) displays server activity logs:</p>
                                    <ul className={"list-unstyled ms-4"}>
                                        <li className={"mb-2"}>View timestamped log entries showing server events and activities.</li>
                                        <li className={"mb-2"}>Filter logs by log event type using the column filter.</li>
                                        <li className={"mb-2"}>Sort and paginate through log entries.</li>
                                        <li className={"mb-2"}>Use logs to troubleshoot issues and monitor server activity.</li>
                                    </ul>
                                </div>
                                : <></>
                            }

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-terminal me-2 text-primary"}></i>Troubleshooting Tab
                                </h5>
                                <p className={"mb-2"}>This tab provides debugging and troubleshooting information:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    {interfaceId === 3
                                        ? <>
                                            <li className={"mb-2"}><strong>Server Status</strong>: View queue counts including process queue, aggregate repeater queue, eman event queue, maintenance queue, and other queues.</li>
                                            <li className={"mb-2"}><strong>Alarm Information</strong>: View recent alarm times and raw/parsed alarm messages (click icons to copy to clipboard).</li>
                                            <li className={"mb-2"}><strong>Last Updated</strong>: Timestamp of when status information was last updated.</li>
                                        </>
                                        : <></>
                                    }
                                    <li className={"mb-2"}><strong>Local Alerts</strong>: Click "Local Alerts" to interrogate the server and retrieve active alerts.</li>
                                    <li className={"mb-2"}><strong>Alert Details</strong>: View event date/time, alert category, alert type, area name, device name, and serial number for local alerts.</li>
                                    <li className={"mb-2"}>Use this information to diagnose communication issues and verify server functionality.</li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Use the collapse/expand icons on card headers to show or hide sections.</li>
                                    <li className={"mb-2"}>Server information automatically refreshes every 10 minutes.</li>
                                    <li className={"mb-2"}>Database validation helps ensure server configuration is correct.</li>
                                    <li className={"mb-2"}>Match terms are critical for proper event processing - test changes carefully.</li>
                                    <li className={"mb-2"}>Monitor online status and last heartbeat to ensure server connectivity.</li>
                                    <li className={"mb-2"}>Queue counts in Server Status help identify processing bottlenecks.</li>
                                    <li className={"mb-2"}>Click on area names to navigate to area profiles.</li>
                                    <li className={"mb-2"}>Use the "Local Alerts" button to retrieve real-time alert information from the server.</li>
                                    <li className={"mb-2"}>Database configuration changes may require server restart to take effect.</li>
                                    {[1, 2].includes(interfaceId)
                                        ? <li className={"mb-2"}>Virtual devices must be created before they can be used in match terms.</li>
                                        : <></>
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default ServerProfile;